// Memory Card Game Data - Educational Content for Kids (English)
// Each category has 20 thematic cards (max 20-pair board); every card display+id+label is UNIQUE

import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
export const CARD_CATEGORIES = {
  letters: {
    name: "Letters",
    icon: "\uD83D\uDD24",
    color: "#FF6B6B",
    cards: [
      { id: "A", display: "A", label: "Latin Capital Letter A", color: "#FF6B6B" },
      { id: "B", display: "B", label: "Latin Capital Letter B", color: "#4ECDC4" },
      { id: "C", display: "C", label: "Latin Capital Letter C", color: "#45B7D1" },
      { id: "D", display: "D", label: "Latin Capital Letter D", color: "#96CEB4" },
      { id: "E", display: "E", label: "Latin Capital Letter E", color: "#FFEAA7" },
      { id: "F", display: "F", label: "Latin Capital Letter F", color: "#DDA0DD" },
      { id: "G", display: "G", label: "Latin Capital Letter G", color: "#98D8C8" },
      { id: "H", display: "H", label: "Latin Capital Letter H", color: "#F7DC6F" },
      { id: "I", display: "I", label: "Latin Capital Letter I", color: "#87CEFA" },
      { id: "J", display: "J", label: "Latin Capital Letter J", color: "#FF69B4" },
      { id: "K", display: "K", label: "Latin Capital Letter K", color: "#FFB347" },
      { id: "L", display: "L", label: "Latin Capital Letter L", color: "#FFD700" },
      { id: "M", display: "M", label: "Latin Capital Letter M", color: "#FF8C00" },
      { id: "N", display: "N", label: "Latin Capital Letter N", color: "#E74C3C" },
      { id: "O", display: "O", label: "Latin Capital Letter O", color: "#1ABC9C" },
      { id: "P", display: "P", label: "Latin Capital Letter P", color: "#2C3E50" },
      { id: "Q", display: "Q", label: "Latin Capital Letter Q", color: "#9B59B6" },
      { id: "R", display: "R", label: "Latin Capital Letter R", color: "#8B4513" },
      { id: "S", display: "S", label: "Latin Capital Letter S", color: "#F39C12" },
      { id: "T", display: "T", label: "Latin Capital Letter T", color: "#95A5A6" },
    
    
    
    
    
    
    
    ]
  },
  numbers: {
    name: "Numbers",
    icon: "\uD83D\uDD22",
    color: "#4ECDC4",
    cards: [
      { id: "1", display: "1\uFE0F\u20E3", label: "Keycap 1", color: "#FF6B6B" },
      { id: "2", display: "2\uFE0F\u20E3", label: "Keycap 2", color: "#4ECDC4" },
      { id: "3", display: "3\uFE0F\u20E3", label: "Keycap 3", color: "#45B7D1" },
      { id: "4", display: "4\uFE0F\u20E3", label: "Keycap 4", color: "#96CEB4" },
      { id: "5", display: "5\uFE0F\u20E3", label: "Keycap 5", color: "#FFEAA7" },
      { id: "6", display: "6\uFE0F\u20E3", label: "Keycap 6", color: "#DDA0DD" },
      { id: "7", display: "7\uFE0F\u20E3", label: "Keycap 7", color: "#98D8C8" },
      { id: "8", display: "8\uFE0F\u20E3", label: "Keycap 8", color: "#F7DC6F" },
      { id: "9", display: "9\uFE0F\u20E3", label: "Keycap 9", color: "#FF69B4" },
      { id: "10", display: "\uD83D\uDD1F", label: "Keycap 10", color: "#87CEEB" },
      { id: "0", display: "0\uFE0F\u20E3", label: "Keycap 0", color: "#C0C0C0" },
      { id: "100", display: "\uD83D\uDCAF", label: "Hundred Points", color: "#FFD700" },
      { id: "11", display: "1\uFE0F\u20E31\uFE0F\u20E3", label: "Keycap 1::keycap 1", color: "#E74C3C" },
      { id: "12", display: "1\uFE0F\u20E32\uFE0F\u20E3", label: "Keycap 1::keycap 2", color: "#3498DB" },
      { id: "13", display: "1\uFE0F\u20E33\uFE0F\u20E3", label: "Keycap 1::keycap 3", color: "#2ECC71" },
      { id: "14", display: "1\uFE0F\u20E34\uFE0F\u20E3", label: "Keycap 1::keycap 4", color: "#9B59B6" },
      { id: "15", display: "1\uFE0F\u20E35\uFE0F\u20E3", label: "Keycap 1::keycap 5", color: "#F39C12" },
      { id: "20", display: "2\uFE0F\u20E30\uFE0F\u20E3", label: "Keycap 2::keycap 0", color: "#1ABC9C" },
      { id: "50", display: "5\uFE0F\u20E30\uFE0F\u20E3", label: "Keycap 5::keycap 0", color: "#E67E22" },
      { id: "99", display: "9\uFE0F\u20E39\uFE0F\u20E3", label: "Keycap 9::keycap 9", color: "#8E44AD" },
    
    
    
    
    
    
    
    ]
  },
  colors: {
    name: "Colors",
    icon: "\uD83C\uDFA8",
    color: "#FF69B4",
    cards: [
      { id: "red", display: "\uD83D\uDD34", label: "Red Circle", color: "#FF0000" },
      { id: "blue", display: "\uD83D\uDD35", label: "Blue Circle", color: "#0000FF" },
      { id: "yellow", display: "\uD83D\uDFE1", label: "Yellow Circle", color: "#FFD700" },
      { id: "green", display: "\uD83D\uDFE2", label: "Green Circle", color: "#00AA00" },
      { id: "orange", display: "\uD83D\uDFE0", label: "Orange Circle", color: "#FF8C00" },
      { id: "purple", display: "\uD83D\uDFE3", label: "Purple Circle", color: "#800080" },
      { id: "brown", display: "\uD83D\uDFE4", label: "Brown Circle", color: "#8B4513" },
      { id: "white", display: "\u26AA", label: "White Circle", color: "#EEEEEE" },
      { id: "black", display: "\u26AB", label: "Black Circle", color: "#1a1a1a" },
      { id: "pink", display: "\uD83D\uDC97", label: "Growing Heart", color: "#FF69B4" },
      { id: "gold", display: "\uD83C\uDF1F", label: "Glowing Star", color: "#FFD700" },
      { id: "silver", display: "\uD83E\uDD4F", label: "Flying Disc", color: "#C0C0C0" },
      { id: "teal", display: "\uD83D\uDC8E", label: "Gem Stone", color: "#00CED1" },
      { id: "lime", display: "\uD83C\uDF4F", label: "Green Apple", color: "#32CD32" },
      { id: "navy", display: "\uD83C\uDF0A", label: "Water Wave", color: "#00008B" },
      { id: "coral", display: "\uD83C\uDF38", label: "Cherry Blossom", color: "#FF7F50" },
      { id: "grey", display: "\uD83E\uDEA8", label: "Rock", color: "#808080" },
      { id: "crimson", display: "\uD83C\uDF39", label: "Rose", color: "#DC143C" },
      { id: "cyan", display: "\uD83E\uDED7", label: "Pouring Liquid", color: "#00FFFF" },
      { id: "magenta", display: "\uD83C\uDF3A", label: "Hibiscus", color: "#FF00FF" },
    
    
    
    
    
    
    
    ]
  },
  animals: {
    name: "Animals",
    icon: "\uD83D\uDC3E",
    color: "#FFB347",
    cards: [
      { id: "cat", display: "\uD83D\uDC31", label: "Cat Face", color: "#FFB347" },
      { id: "dog", display: "\uD83D\uDC36", label: "Dog Face", color: "#87CEEB" },
      { id: "bird", display: "\uD83D\uDC26", label: "Bird", color: "#98FB98" },
      { id: "fish", display: "\uD83D\uDC1F", label: "Fish", color: "#87CEFA" },
      { id: "elephant", display: "\uD83D\uDC18", label: "Elephant", color: "#D3D3D3" },
      { id: "lion", display: "\uD83E\uDD81", label: "Lion", color: "#F4A460" },
      { id: "rabbit", display: "\uD83D\uDC30", label: "Rabbit Face", color: "#FFB6C1" },
      { id: "turtle", display: "\uD83D\uDC22", label: "Turtle", color: "#90EE90" },
      { id: "panda", display: "\uD83D\uDC3C", label: "Panda", color: "#2C3E50" },
      { id: "monkey", display: "\uD83D\uDC35", label: "Monkey Face", color: "#8B4513" },
      { id: "dolphin", display: "\uD83D\uDC2C", label: "Dolphin", color: "#4682B4" },
      { id: "penguin", display: "\uD83D\uDC27", label: "Penguin", color: "#2F4F4F" },
      { id: "giraffe", display: "\uD83E\uDD92", label: "Giraffe", color: "#DAA520" },
      { id: "zebra", display: "\uD83E\uDD93", label: "Zebra", color: "#2C3E50" },
      { id: "koala", display: "\uD83D\uDC28", label: "Koala", color: "#808080" },
      { id: "bear", display: "\uD83D\uDC3B", label: "Bear", color: "#8B4513" },
      { id: "fox", display: "\uD83E\uDD8A", label: "Fox", color: "#FF8C00" },
      { id: "tiger", display: "\uD83D\uDC2F", label: "Tiger Face", color: "#FF8C00" },
      { id: "cow", display: "\uD83D\uDC2E", label: "Cow Face", color: "#FFEAA7" },
      { id: "pig", display: "\uD83D\uDC37", label: "Pig Face", color: "#FFB6C1" },
    
    
    
    
    
    
    
    ]
  },
  fruits: {
    name: "Fruits",
    icon: "\uD83C\uDF4E",
    color: "#FF6347",
    cards: [
      { id: "apple", display: "\uD83C\uDF4E", label: "Red Apple", color: "#FF6347" },
      { id: "banana", display: "\uD83C\uDF4C", label: "Banana", color: "#FFE135" },
      { id: "orange_f", display: "\uD83C\uDF4A", label: "Tangerine", color: "#FFA500" },
      { id: "grapes", display: "\uD83C\uDF47", label: "Grapes", color: "#6B238E" },
      { id: "watermelon", display: "\uD83C\uDF49", label: "Watermelon", color: "#FF6B6B" },
      { id: "strawberry", display: "\uD83C\uDF53", label: "Strawberry", color: "#FF4500" },
      { id: "cherry", display: "\uD83C\uDF52", label: "Cherries", color: "#DC143C" },
      { id: "lemon", display: "\uD83C\uDF4B", label: "Lemon", color: "#FFF44F" },
      { id: "mango", display: "\uD83E\uDD6D", label: "Mango", color: "#FFB347" },
      { id: "coconut", display: "\uD83E\uDD65", label: "Coconut", color: "#8B4513" },
      { id: "peach", display: "\uD83C\uDF51", label: "Peach", color: "#FFDAB9" },
      { id: "pineapple", display: "\uD83C\uDF4D", label: "Pineapple", color: "#FFD700" },
      { id: "pear", display: "\uD83C\uDF50", label: "Pear", color: "#9ACD32" },
      { id: "melon", display: "\uD83C\uDF48", label: "Melon", color: "#98FB98" },
      { id: "kiwi", display: "\uD83E\uDD5D", label: "Kiwi Fruit", color: "#6B8E23" },
      { id: "blueberry", display: "\uD83E\uDED0", label: "Blueberries", color: "#4169E1" },
      { id: "avocado", display: "\uD83E\uDD51", label: "Avocado", color: "#228B22" },
      { id: "greenapple", display: "\uD83C\uDF4F", label: "Green Apple", color: "#32CD32" },
      { id: "plum", display: "\uD83E\uDED2", label: "Olive Plum", color: "#8E4585" },
      { id: "tomato", display: "\uD83C\uDF45", label: "Tomato Fruit", color: "#FF6347" },
    
    
    
    
    
    
    
    ]
  },
  shapes: {
    name: "Shapes",
    icon: "\u2B21",
    color: "#FFD700",
    cards: [
      { id: "circle", display: "\u2B55", label: "Hollow Red Circle", color: "#FF6B6B" },
      { id: "square", display: "\u2B1C", label: "White Large Square", color: "#4ECDC4" },
      { id: "triangle", display: "\uD83D\uDD3A", label: "Red Triangle Pointed Up", color: "#FFD93D" },
      { id: "star", display: "\u2B50", label: "Star", color: "#FFD700" },
      { id: "heart", display: "\u2764\uFE0F", label: "Red Heart", color: "#FF69B4" },
      { id: "diamond", display: "\uD83D\uDC8E", label: "Gem Stone", color: "#00CED1" },
      { id: "moon", display: "\uD83C\uDF19", label: "Crescent Moon", color: "#F0E68C" },
      { id: "sun", display: "\u2600\uFE0F", label: "Sun", color: "#FFD700" },
      { id: "plus", display: "\u2795", label: "Plus", color: "#32CD32" },
      { id: "arrow", display: "\u27A1\uFE0F", label: "Right Arrow", color: "#4169E1" },
      { id: "bolt", display: "\u26A1", label: "High Voltage", color: "#FFD700" },
      { id: "fire", display: "\uD83D\uDD25", label: "Fire", color: "#FF4500" },
      { id: "cloud", display: "\u2601\uFE0F", label: "Cloud", color: "#87CEEB" },
      { id: "rainbow", display: "\uD83C\uDF08", label: "Rainbow", color: "#FF69B4" },
      { id: "snowflake", display: "\u2744\uFE0F", label: "Snowflake", color: "#E0FFFF" },
      { id: "drop", display: "\uD83D\uDCA7", label: "Droplet", color: "#4682B4" },
      { id: "spiral", display: "\uD83C\uDF00", label: "Cyclone", color: "#9B59B6" },
      { id: "ribbon", display: "\uD83C\uDF80", label: "Ribbon", color: "#FF69B4" },
      { id: "crystal", display: "\uD83D\uDD2E", label: "Crystal Ball", color: "#9B59B6" },
      { id: "hexagon", display: "\u2B21", label: "White Hexagon", color: "#2ECC71" },
    
    
    
    
    
    
    
    ]
  },
  vehicles: {
    name: "Vehicles",
    icon: "\uD83D\uDE97",
    color: "#45B7D1",
    cards: [
      { id: "car", display: "\uD83D\uDE97", label: "Automobile", color: "#FF6B6B" },
      { id: "bus", display: "\uD83D\uDE8C", label: "Bus", color: "#4ECDC4" },
      { id: "train", display: "\uD83D\uDE82", label: "Locomotive", color: "#45B7D1" },
      { id: "plane", display: "\u2708\uFE0F", label: "Airplane", color: "#87CEEB" },
      { id: "ship", display: "\uD83D\uDEA2", label: "Ship", color: "#1E90FF" },
      { id: "bicycle", display: "\uD83D\uDEB2", label: "Bicycle", color: "#32CD32" },
      { id: "helicopter", display: "\uD83D\uDE81", label: "Helicopter", color: "#FF8C00" },
      { id: "truck", display: "\uD83D\uDE9A", label: "Delivery Truck", color: "#8B4513" },
      { id: "ambulance", display: "\uD83D\uDE91", label: "Ambulance", color: "#FF0000" },
      { id: "taxi", display: "\uD83D\uDE95", label: "Taxi", color: "#FFD700" },
      { id: "motorcycle", display: "\uD83C\uDFCD\uFE0F", label: "Motorcycle", color: "#2C3E50" },
      { id: "sailboat", display: "\u26F5", label: "Sailboat", color: "#1E90FF" },
      { id: "rocket", display: "\uD83D\uDE80", label: "Rocket", color: "#FF4500" },
      { id: "tractor", display: "\uD83D\uDE9C", label: "Tractor", color: "#228B22" },
      { id: "firetruck", display: "\uD83D\uDE92", label: "Fire Engine", color: "#FF0000" },
      { id: "police", display: "\uD83D\uDE93", label: "Police Car", color: "#1E3A5F" },
      { id: "bullet_train", display: "\uD83D\uDE85", label: "Bullet Train", color: "#E0E0E0" },
      { id: "scooter", display: "\uD83D\uDEF4", label: "Kick Scooter", color: "#32CD32" },
      { id: "speedboat", display: "\uD83D\uDEA4", label: "Speedboat", color: "#4682B4" },
      { id: "balloon_v", display: "\uD83C\uDF88", label: "Balloon", color: "#FF69B4" },
    
    
    
    
    
    
    
    ]
  },
  food: {
    name: "Food",
    icon: "\uD83C\uDF5C",
    color: "#FF8C00",
    cards: [
      { id: "rice", display: "\uD83C\uDF5A", label: "Cooked Rice", color: "#FFFACD" },
      { id: "bread", display: "\uD83C\uDF5E", label: "Bread", color: "#DEB887" },
      { id: "pizza", display: "\uD83C\uDF55", label: "Pizza", color: "#FF6347" },
      { id: "icecream", display: "\uD83C\uDF66", label: "Soft Ice Cream", color: "#FFB6C1" },
      { id: "cake", display: "\uD83C\uDF82", label: "Birthday Cake", color: "#FF69B4" },
      { id: "noodle", display: "\uD83C\uDF5C", label: "Steaming Bowl", color: "#FFD700" },
      { id: "burger", display: "\uD83C\uDF54", label: "Hamburger", color: "#8B4513" },
      { id: "donut", display: "\uD83C\uDF69", label: "Doughnut", color: "#FF69B4" },
      { id: "sushi", display: "\uD83C\uDF63", label: "Sushi", color: "#FF6347" },
      { id: "fries", display: "\uD83C\uDF5F", label: "French Fries", color: "#FFD700" },
      { id: "taco", display: "\uD83C\uDF2E", label: "Taco", color: "#FF8C00" },
      { id: "popcorn", display: "\uD83C\uDF7F", label: "Popcorn", color: "#FFFACD" },
      { id: "hotdog", display: "\uD83C\uDF2D", label: "Hot Dog", color: "#FF6347" },
      { id: "pancake", display: "\uD83E\uDD5E", label: "Pancakes", color: "#DEB887" },
      { id: "egg", display: "\uD83C\uDF73", label: "Cooking", color: "#FFD700" },
      { id: "sandwich", display: "\uD83E\uDD6A", label: "Sandwich", color: "#DEB887" },
      { id: "candy", display: "\uD83C\uDF6C", label: "Candy", color: "#FF69B4" },
      { id: "chocolate", display: "\uD83C\uDF6B", label: "Chocolate Bar", color: "#8B4513" },
      { id: "cookie", display: "\uD83C\uDF6A", label: "Cookie", color: "#D2B48C" },
      { id: "pretzel", display: "\uD83E\uDD68", label: "Pretzel", color: "#D2B48C" },
    
    
    
    
    
    
    
    ]
  },
  jobs: {
    name: "Jobs",
    icon: "\uD83D\uDC68\u200D\u2695\uFE0F",
    color: "#6B238E",
    cards: [
      { id: "doctor", display: "\uD83D\uDC68\u200D\u2695\uFE0F", label: "Man Health Worker", color: "#FFFFFF" },
      { id: "teacher", display: "\uD83D\uDC69\u200D\uD83C\uDFEB", label: "Woman Teacher", color: "#4ECDC4" },
      { id: "pilot", display: "\uD83D\uDC68\u200D\u2708\uFE0F", label: "Man Pilot", color: "#87CEEB" },
      { id: "police_j", display: "\uD83D\uDC6E", label: "Police Officer", color: "#1E3A5F" },
      { id: "farmer", display: "\uD83D\uDC68\u200D\uD83C\uDF3E", label: "Man Farmer", color: "#228B22" },
      { id: "chef", display: "\uD83D\uDC68\u200D\uD83C\uDF73", label: "Man Cook", color: "#FF6347" },
      { id: "astronaut", display: "\uD83D\uDC68\u200D\uD83D\uDE80", label: "Man Astronaut", color: "#C0C0C0" },
      { id: "firefighter", display: "\uD83D\uDC68\u200D\uD83D\uDE92", label: "Man Firefighter", color: "#FF4500" },
      { id: "scientist", display: "\uD83D\uDC68\u200D\uD83D\uDD2C", label: "Man Scientist", color: "#4ECDC4" },
      { id: "artist", display: "\uD83D\uDC68\u200D\uD83C\uDFA8", label: "Man Artist", color: "#FF69B4" },
      { id: "singer", display: "\uD83D\uDC68\u200D\uD83C\uDFA4", label: "Man Singer", color: "#9B59B6" },
      { id: "mechanic", display: "\uD83D\uDC68\u200D\uD83D\uDD27", label: "Man Mechanic", color: "#2C3E50" },
      { id: "detective", display: "\uD83D\uDD75\uFE0F", label: "Detective", color: "#2C3E50" },
      { id: "judge", display: "\uD83D\uDC68\u200D\u2696\uFE0F", label: "Man Judge", color: "#2C3E50" },
      { id: "ninja", display: "\uD83E\uDD77", label: "Ninja", color: "#1a1a1a" },
      { id: "athlete", display: "\uD83C\uDFC3", label: "Person Running", color: "#FF8C00" },
      { id: "nurse", display: "\uD83D\uDC69\u200D\u2695\uFE0F", label: "Woman Health Worker", color: "#FF69B4" },
      { id: "fisher", display: "\uD83C\uDFA3", label: "Fishing Pole", color: "#4682B4" },
      { id: "coder", display: "\uD83D\uDC68\u200D\uD83D\uDCBB", label: "Man Technologist", color: "#3498DB" },
      { id: "builder", display: "\uD83D\uDC77", label: "Construction Worker", color: "#FF8C00" },
    
    
    
    
    
    
    
    ]
  },
  weather: {
    name: "Weather",
    icon: "\uD83C\uDF24\uFE0F",
    color: "#87CEEB",
    cards: [
      { id: "sunny", display: "\u2600\uFE0F", label: "Sun", color: "#FFD700" },
      { id: "rainy", display: "\uD83C\uDF27\uFE0F", label: "Cloud With Rain", color: "#4682B4" },
      { id: "cloudy", display: "\u2601\uFE0F", label: "Cloud", color: "#D3D3D3" },
      { id: "rainbow_w", display: "\uD83C\uDF08", label: "Rainbow", color: "#FF69B4" },
      { id: "snowy", display: "\u2744\uFE0F", label: "Snowflake", color: "#E0FFFF" },
      { id: "windy", display: "\uD83C\uDF2C\uFE0F", label: "Wind Face", color: "#B0C4DE" },
      { id: "thunder", display: "\u26A1", label: "High Voltage", color: "#FFD700" },
      { id: "tornado", display: "\uD83C\uDF2A\uFE0F", label: "Tornado", color: "#808080" },
      { id: "foggy", display: "\uD83C\uDF2B\uFE0F", label: "Fog", color: "#A9A9A9" },
      { id: "sunset", display: "\uD83C\uDF05", label: "Sunrise", color: "#FF8C00" },
      { id: "night", display: "\uD83C\uDF03", label: "Night With Stars", color: "#191970" },
      { id: "starry", display: "\uD83C\uDF1F", label: "Glowing Star", color: "#FFD700" },
      { id: "dawn", display: "\uD83C\uDF04", label: "Sunrise Over Mountains", color: "#FF8C00" },
      { id: "hot", display: "\uD83C\uDF21\uFE0F", label: "Thermometer", color: "#FF4500" },
      { id: "umbrella", display: "\u2602\uFE0F", label: "Umbrella", color: "#4ECDC4" },
      { id: "dew", display: "\uD83D\uDCA7", label: "Droplet", color: "#87CEEB" },
      { id: "overcast", display: "\uD83C\uDF25\uFE0F", label: "Sun Behind Large Cloud", color: "#808080" },
      { id: "drizzle", display: "\uD83C\uDF26\uFE0F", label: "Sun Behind Rain Cloud", color: "#B0C4DE" },
      { id: "aurora", display: "\uD83C\uDF0C", label: "Milky Way", color: "#9B59B6" },
      { id: "hail", display: "\uD83C\uDF28\uFE0F", label: "Cloud With Snow", color: "#E0FFFF" },
    
    
    
    
    
    
    
    ]
  },
  sports: {
    name: "Sports",
    icon: "\u26BD",
    color: "#E67E22",
    cards: [
      { id: "soccer", display: "\u26BD", label: "Soccer Ball", color: "#228B22" },
      { id: "basketball", display: "\uD83C\uDFC0", label: "Basketball", color: "#FF8C00" },
      { id: "tennis", display: "\uD83C\uDFBE", label: "Tennis", color: "#ADFF2F" },
      { id: "swimming", display: "\uD83C\uDFCA", label: "Person Swimming", color: "#1E90FF" },
      { id: "cycling", display: "\uD83D\uDEB4", label: "Person Biking", color: "#FF6347" },
      { id: "badminton", display: "\uD83C\uDFF8", label: "Badminton", color: "#4ECDC4" },
      { id: "golf", display: "\u26F3", label: "Flag In Hole", color: "#228B22" },
      { id: "boxing", display: "\uD83E\uDD4A", label: "Boxing Glove", color: "#DC143C" },
      { id: "skiing", display: "\u26F7\uFE0F", label: "Skier", color: "#87CEEB" },
      { id: "climbing", display: "\uD83E\uDDD7", label: "Person Climbing", color: "#8B4513" },
      { id: "surfing", display: "\uD83C\uDFC4", label: "Person Surfing", color: "#1E90FF" },
      { id: "weightlifting", display: "\uD83C\uDFCB\uFE0F", label: "Person Lifting Weights", color: "#2C3E50" },
      { id: "running", display: "\uD83C\uDFC3", label: "Person Running", color: "#FF8C00" },
      { id: "archery", display: "\uD83C\uDFF9", label: "Bow And Arrow", color: "#228B22" },
      { id: "baseball", display: "\u26BE", label: "Baseball", color: "#FF6347" },
      { id: "football", display: "\uD83C\uDFC8", label: "American Football", color: "#8B4513" },
      { id: "hockey", display: "\uD83C\uDFD2", label: "Ice Hockey", color: "#87CEEB" },
      { id: "volleyball", display: "\uD83C\uDFD0", label: "Volleyball", color: "#FFD700" },
      { id: "skateboard", display: "\uD83D\uDEF9", label: "Skateboard", color: "#2C3E50" },
      { id: "pingpong", display: "\uD83C\uDFD3", label: "Ping Pong", color: "#FF6347" },
    
    
    
    
    
    
    
    ]
  },
  emotions: {
    name: "Emotions",
    icon: "\uD83D\uDE00",
    color: "#F1C40F",
    cards: [
      { id: "happy", display: "\uD83D\uDE04", label: "Grinning Face With Smiling Eyes", color: "#FFD700" },
      { id: "sad", display: "\uD83D\uDE22", label: "Crying Face", color: "#4682B4" },
      { id: "angry", display: "\uD83D\uDE21", label: "Enraged Face", color: "#FF0000" },
      { id: "scared", display: "\uD83D\uDE28", label: "Fearful Face", color: "#9B59B6" },
      { id: "surprised", display: "\uD83D\uDE32", label: "Astonished Face", color: "#FF8C00" },
      { id: "shy", display: "\uD83D\uDE33", label: "Flushed Face", color: "#FF69B4" },
      { id: "thinking", display: "\uD83E\uDD14", label: "Thinking Face", color: "#87CEEB" },
      { id: "love", display: "\uD83E\uDD70", label: "Smiling Face With Hearts", color: "#FF1493" },
      { id: "cool", display: "\uD83D\uDE0E", label: "Smiling Face With Sunglasses", color: "#2C3E50" },
      { id: "sleepy", display: "\uD83D\uDE34", label: "Sleeping Face", color: "#9B59B6" },
      { id: "hungry", display: "\uD83E\uDD24", label: "Drooling Face", color: "#FF8C00" },
      { id: "sick", display: "\uD83E\uDD12", label: "Face With Thermometer", color: "#32CD32" },
      { id: "laughing", display: "\uD83D\uDE02", label: "Face With Tears Of Joy", color: "#FFD700" },
      { id: "crying", display: "\uD83D\uDE2D", label: "Loudly Crying Face", color: "#4682B4" },
      { id: "excited", display: "\uD83E\uDD29", label: "Star Struck", color: "#FFD700" },
      { id: "worried", display: "\uD83D\uDE1F", label: "Worried Face", color: "#FF8C00" },
      { id: "proud", display: "\uD83E\uDD73", label: "Partying Face", color: "#FF69B4" },
      { id: "relaxed", display: "\uD83D\uDE0C", label: "Relieved Face", color: "#4ECDC4" },
      { id: "confused", display: "\uD83E\uDDD0", label: "Face With Monocle", color: "#9B59B6" },
      { id: "annoyed", display: "\uD83D\uDE24", label: "Face With Steam From Nose", color: "#FF4500" },
    
    
    
    
    
    
    
    ]
  },
  body: {
    name: "Body",
    icon: "\uD83E\uDDB4",
    color: "#E74C3C",
    cards: [
      { id: "eye", display: "\uD83D\uDC41\uFE0F", label: "Eye", color: "#45B7D1" },
      { id: "ear", display: "\uD83D\uDC42", label: "Ear", color: "#FFB347" },
      { id: "nose", display: "\uD83D\uDC43", label: "Nose", color: "#DEB887" },
      { id: "mouth", display: "\uD83D\uDC44", label: "Mouth", color: "#FF6B6B" },
      { id: "hand", display: "\u270B", label: "Raised Hand", color: "#FFDAB9" },
      { id: "foot", display: "\uD83E\uDDB6", label: "Foot", color: "#D2B48C" },
      { id: "brain", display: "\uD83E\uDDE0", label: "Brain", color: "#FF69B4" },
      { id: "heart_b", display: "\u2764\uFE0F", label: "Red Heart", color: "#DC143C" },
      { id: "tooth", display: "\uD83E\uDDB7", label: "Tooth", color: "#FFFFFF" },
      { id: "bone", display: "\uD83E\uDDB4", label: "Bone", color: "#FFFACD" },
      { id: "muscle", display: "\uD83D\uDCAA", label: "Flexed Biceps", color: "#FF6347" },
      { id: "tongue", display: "\uD83D\uDC45", label: "Tongue", color: "#FF69B4" },
      { id: "finger", display: "\uD83D\uDC46", label: "Backhand Index Pointing Up", color: "#FFDAB9" },
      { id: "leg", display: "\uD83E\uDDB5", label: "Leg", color: "#D2B48C" },
      { id: "lungs", display: "\uD83E\uDEC1", label: "Lungs", color: "#FF69B4" },
      { id: "blood", display: "\uD83E\uDE78", label: "Drop Of Blood", color: "#DC143C" },
      { id: "dna", display: "\uD83E\uDDEC", label: "Dna", color: "#4ECDC4" },
      { id: "skull", display: "\uD83D\uDC80", label: "Skull", color: "#FFFACD" },
      { id: "eyes", display: "\uD83D\uDC40", label: "Eyes", color: "#45B7D1" },
      { id: "lips", display: "\uD83D\uDC8B", label: "Kiss Mark", color: "#FF69B4" },
    
    
    
    
    
    
    
    ]
  },
  space: {
    name: "Space",
    icon: "\uD83C\uDF0D",
    color: "#3498DB",
    cards: [
      { id: "earth", display: "\uD83C\uDF0D", label: "Globe Showing Europe Africa", color: "#4ECDC4" },
      { id: "moon_s", display: "\uD83C\uDF15", label: "Full Moon", color: "#F0E68C" },
      { id: "sun_s", display: "\u2600\uFE0F", label: "Sun", color: "#FFD700" },
      { id: "mars", display: "\uD83D\uDD34", label: "Red Circle", color: "#FF4500" },
      { id: "saturn", display: "\uD83E\uDE90", label: "Ringed Planet", color: "#DAA520" },
      { id: "star_s", display: "\u2B50", label: "Star", color: "#FFD700" },
      { id: "rocket_s", display: "\uD83D\uDE80", label: "Rocket", color: "#FF6347" },
      { id: "galaxy", display: "\uD83C\uDF0C", label: "Milky Way", color: "#9B59B6" },
      { id: "comet", display: "\u2604\uFE0F", label: "Comet", color: "#87CEEB" },
      { id: "ufo", display: "\uD83D\uDEF8", label: "Flying Saucer", color: "#32CD32" },
      { id: "satellite", display: "\uD83D\uDEF0\uFE0F", label: "Satellite", color: "#C0C0C0" },
      { id: "telescope", display: "\uD83D\uDD2D", label: "Telescope", color: "#2C3E50" },
      { id: "astronaut_s", display: "\uD83D\uDC68\u200D\uD83D\uDE80", label: "Man Astronaut", color: "#C0C0C0" },
      { id: "alien", display: "\uD83D\uDC7D", label: "Alien", color: "#32CD32" },
      { id: "venus", display: "\uD83D\uDFE0", label: "Orange Circle", color: "#FF8C00" },
      { id: "jupiter", display: "\uD83D\uDFE4", label: "Brown Circle", color: "#DEB887" },
      { id: "neptune", display: "\uD83D\uDD35", label: "Blue Circle", color: "#1E90FF" },
      { id: "pluto", display: "\u26AA", label: "White Circle", color: "#D3D3D3" },
      { id: "meteor", display: "\uD83C\uDF12", label: "Waxing Crescent Moon", color: "#FF8C00" },
      { id: "nebula", display: "\uD83C\uDF1F", label: "Glowing Star", color: "#9B59B6" },
    
    
    
    
    
    
    
    ]
  },
  bugs: {
    name: "Bugs",
    icon: "\uD83D\uDC1B",
    color: "#8BC34A",
    cards: [
      { id: "butterfly", display: "\uD83E\uDD8B", label: "Butterfly", color: "#FF69B4" },
      { id: "bee", display: "\uD83D\uDC1D", label: "Honeybee", color: "#FFD700" },
      { id: "ant", display: "\uD83D\uDC1C", label: "Ant", color: "#8B4513" },
      { id: "caterpillar", display: "\uD83D\uDC1B", label: "Caterpillar Bug", color: "#32CD32" },
      { id: "ladybug", display: "\uD83D\uDC1E", label: "Lady Beetle", color: "#FF0000" },
      { id: "spider", display: "\uD83D\uDD77\uFE0F", label: "Spider", color: "#2C3E50" },
      { id: "spider_web", display: "\uD83D\uDD78\uFE0F", label: "Spider Web", color: "#A9A9A9" },
      { id: "mosquito", display: "\uD83E\uDD9F", label: "Mosquito", color: "#808080" },
      { id: "beetle", display: "\uD83E\uDEB2", label: "Beetle", color: "#4ECDC4" },
      { id: "cricket", display: "\uD83E\uDD97", label: "Cricket", color: "#228B22" },
      { id: "cockroach", display: "\uD83E\uDEB3", label: "Cockroach", color: "#8B4513" },
      { id: "worm", display: "\uD83E\uDEB1", label: "Worm", color: "#FF69B4" },
      { id: "snail", display: "\uD83D\uDC0C", label: "Snail", color: "#D2B48C" },
      { id: "scorpion", display: "\uD83E\uDD82", label: "Scorpion", color: "#FF4500" },
      { id: "fly", display: "\uD83E\uDEB0", label: "Fly", color: "#2C3E50" },
      { id: "microbe", display: "\uD83E\uDDA0", label: "Microbe", color: "#9B59B6" },
      { id: "lizard_bug", display: "\uD83E\uDD8E", label: "Lizard Bug", color: "#228B22" },
      { id: "turtle_bug", display: "\uD83D\uDC22", label: "Turtle Bug", color: "#228B22" },
      { id: "shell_bug", display: "\uD83D\uDC1A", label: "Spiral Shell Bug", color: "#FFB6C1" },
      { id: "frog_bug", display: "\uD83D\uDC38", label: "Frog Bug", color: "#228B22" },
    
    
    
    
    
    
    
    ]
  },
  flags: {
    name: "Flags",
    icon: "\uD83C\uDFF3\uFE0F",
    color: "#F44336",
    cards: [
      { id: "indonesia", display: "\uD83C\uDDEE\uD83C\uDDE9", label: "Indonesia", color: "#FF0000" },
      { id: "japan", display: "\uD83C\uDDEF\uD83C\uDDF5", label: "Japan", color: "#FF0000" },
      { id: "korea", display: "\uD83C\uDDF0\uD83C\uDDF7", label: "South Korea", color: "#1E3A5F" },
      { id: "usa", display: "\uD83C\uDDFA\uD83C\uDDF8", label: "United States", color: "#1E3A5F" },
      { id: "uk", display: "\uD83C\uDDEC\uD83C\uDDE7", label: "United Kingdom", color: "#DC143C" },
      { id: "france", display: "\uD83C\uDDEB\uD83C\uDDF7", label: "France", color: "#1E90FF" },
      { id: "brazil", display: "\uD83C\uDDE7\uD83C\uDDF7", label: "Brazil", color: "#228B22" },
      { id: "australia", display: "\uD83C\uDDE6\uD83C\uDDFA", label: "Australia", color: "#1E3A5F" },
      { id: "india", display: "\uD83C\uDDEE\uD83C\uDDF3", label: "India", color: "#FF8C00" },
      { id: "china", display: "\uD83C\uDDE8\uD83C\uDDF3", label: "China", color: "#FF0000" },
      { id: "germany", display: "\uD83C\uDDE9\uD83C\uDDEA", label: "Germany", color: "#2C3E50" },
      { id: "italy", display: "\uD83C\uDDEE\uD83C\uDDF9", label: "Italy", color: "#228B22" },
      { id: "spain", display: "\uD83C\uDDEA\uD83C\uDDF8", label: "Spain", color: "#FF0000" },
      { id: "mexico", display: "\uD83C\uDDF2\uD83C\uDDFD", label: "Mexico", color: "#228B22" },
      { id: "canada", display: "\uD83C\uDDE8\uD83C\uDDE6", label: "Canada", color: "#FF0000" },
      { id: "russia", display: "\uD83C\uDDF7\uD83C\uDDFA", label: "Russia", color: "#1E90FF" },
      { id: "turkey", display: "\uD83C\uDDF9\uD83C\uDDF7", label: "Türkiye", color: "#FF0000" },
      { id: "egypt", display: "\uD83C\uDDEA\uD83C\uDDEC", label: "Egypt", color: "#2C3E50" },
      { id: "singapore", display: "\uD83C\uDDF8\uD83C\uDDEC", label: "Singapore", color: "#FF0000" },
      { id: "thailand", display: "\uD83C\uDDF9\uD83C\uDDED", label: "Thailand", color: "#1E3A5F" },
    
    
    
    
    
    
    
    ]
  },
  dinosaurs: {
    name: "Dinosaurs",
    icon: "\uD83E\uDD96",
    color: "#4CAF50",
    cards: [
      { id: "trex", display: "\uD83E\uDD96", label: "T Rex", color: "#228B22" },
      { id: "raptor", display: "\uD83E\uDD95", label: "Sauropod", color: "#8B4513" },
      { id: "triceratops", display: "\uD83E\uDD8E", label: "Lizard", color: "#808080" },
      { id: "stego", display: "\uD83D\uDC09", label: "Dragon", color: "#32CD32" },
      { id: "bronto", display: "\uD83D\uDC0A", label: "Crocodile", color: "#2C3E50" },
      { id: "ptero", display: "\uD83E\uDD85", label: "Eagle", color: "#87CEEB" },
      { id: "fossil", display: "\uD83E\uDDB4", label: "Bone", color: "#DEB887" },
      { id: "dino_egg", display: "\uD83E\uDD5A", label: "Egg", color: "#FFFACD" },
      { id: "footprint", display: "\uD83E\uDDB6", label: "Foot", color: "#D2B48C" },
      { id: "volcano", display: "\uD83C\uDF0B", label: "Volcano", color: "#FF4500" },
      { id: "meteor_d", display: "\u2604\uFE0F", label: "Comet", color: "#FF8C00" },
      { id: "mammoth", display: "\uD83E\uDDA3", label: "Mammoth", color: "#8B4513" },
      { id: "dodo", display: "\uD83E\uDD86", label: "Duck", color: "#808080" },
      { id: "jungle", display: "\uD83C\uDF33", label: "Deciduous Tree", color: "#006400" },
      { id: "amber", display: "\uD83D\uDC1E", label: "Lady Beetle Amber", color: "#FF8C00" },
      { id: "fern", display: "\uD83C\uDF3F", label: "Herb Fern", color: "#228B22" },
      { id: "claw", display: "\uD83C\uDF32", label: "Pine Tree Forest", color: "#006400" },
      { id: "cave", display: "\u26F0\uFE0F", label: "Mountain", color: "#808080" },
      { id: "swamp", display: "\uD83C\uDF3E", label: "Sheaf Of Rice", color: "#006400" },
      { id: "rock", display: "\uD83E\uDEA8", label: "Rock", color: "#808080" },
    
    
    
    
    
    
    
    ]
  },
  school: {
    name: "School",
    icon: "\uD83C\uDFEB",
    color: "#FF9800",
    cards: [
      { id: "book", display: "\uD83D\uDCD6", label: "Open Book", color: "#4ECDC4" },
      { id: "pencil", display: "\u270F\uFE0F", label: "Pencil", color: "#FFD700" },
      { id: "eraser", display: "\uD83D\uDCDC", label: "Scroll", color: "#FF69B4" },
      { id: "ruler", display: "\uD83D\uDCCF", label: "Straight Ruler", color: "#4682B4" },
      { id: "crayon", display: "\uD83D\uDD8D\uFE0F", label: "Crayon", color: "#FF6347" },
      { id: "scissors", display: "\u2702\uFE0F", label: "Scissors", color: "#C0C0C0" },
      { id: "glue", display: "\uD83D\uDCCE", label: "Paperclip", color: "#FFD700" },
      { id: "backpack", display: "\uD83C\uDF92", label: "Backpack", color: "#FF6347" },
      { id: "globe", display: "\uD83C\uDF0D", label: "Globe Showing Europe Africa", color: "#4ECDC4" },
      { id: "calculator", display: "\uD83E\uDDEE", label: "Abacus Calculator", color: "#2C3E50" },
      { id: "microscope", display: "\uD83D\uDD2C", label: "Microscope", color: "#C0C0C0" },
      { id: "palette", display: "\uD83C\uDFA8", label: "Artist Palette", color: "#FF69B4" },
      { id: "paper", display: "\uD83D\uDCC4", label: "Page Facing Up", color: "#FFFACD" },
      { id: "pen", display: "\uD83D\uDD8A\uFE0F", label: "Pen", color: "#1E90FF" },
      { id: "trophy_s", display: "\uD83C\uDFC6", label: "Trophy", color: "#FFD700" },
      { id: "bell", display: "\uD83D\uDD14", label: "Bell", color: "#FFD700" },
      { id: "graduation", display: "\uD83C\uDF93", label: "Graduation Cap", color: "#2C3E50" },
      { id: "abc", display: "\uD83D\uDD24", label: "Input Latin Letters", color: "#FF6B6B" },
      { id: "notebook", display: "\uD83D\uDCD3", label: "Notebook", color: "#4ECDC4" },
      { id: "compass", display: "\uD83E\uDDED", label: "Compass", color: "#FF8C00" },
    
    
    
    
    
    
    
    ]
  },
  music: {
    name: "Music",
    icon: "\uD83C\uDFB5",
    color: "#9B59B6",
    cards: [
      { id: "guitar", display: "\uD83C\uDFB8", label: "Guitar", color: "#8B4513" },
      { id: "piano", display: "\uD83C\uDFB9", label: "Musical Keyboard", color: "#2C3E50" },
      { id: "drum", display: "\uD83E\uDD41", label: "Drum", color: "#E74C3C" },
      { id: "violin", display: "\uD83C\uDFBB", label: "Violin", color: "#D4A574" },
      { id: "trumpet", display: "\uD83C\uDFBA", label: "Trumpet", color: "#FFD700" },
      { id: "mic", display: "\uD83C\uDFA4", label: "Microphone", color: "#C0C0C0" },
      { id: "saxophone", display: "\uD83C\uDFB7", label: "Saxophone", color: "#DAA520" },
      { id: "headphones", display: "\uD83C\uDFA7", label: "Headphone", color: "#2C3E50" },
      { id: "music_note", display: "\uD83C\uDFB5", label: "Musical Note", color: "#9B59B6" },
      { id: "radio", display: "\uD83D\uDCFB", label: "Radio", color: "#8B4513" },
      { id: "speaker", display: "\uD83D\uDD0A", label: "Speaker High Volume", color: "#2C3E50" },
      { id: "harp", display: "\uD83E\uDE95", label: "Banjo", color: "#DAA520" },
      { id: "accordion", display: "\uD83E\uDE97", label: "Accordion", color: "#E74C3C" },
      { id: "banjo", display: "\uD83C\uDFBC", label: "Musical Score", color: "#D4A574" },
      { id: "bell_m", display: "\uD83D\uDD14", label: "Bell", color: "#FFD700" },
      { id: "maracas", display: "\uD83E\uDE87", label: "Maracas", color: "#FF6B6B" },
      { id: "cd", display: "\uD83D\uDCBF", label: "Optical Disk", color: "#C0C0C0" },
      { id: "flute", display: "\uD83E\uDE88", label: "Flute", color: "#C0C0C0" },
      { id: "score", display: "\uD83C\uDFA9", label: "Top Hat", color: "#4ECDC4" },
      { id: "tambourine", display: "\uD83C\uDF99\uFE0F", label: "Studio Microphone", color: "#FFD700" },
    
    
    
    
    
    
    
    ]
  },
  clothing: {
    name: "Clothing",
    icon: "\uD83D\uDC57",
    color: "#E91E63",
    cards: [
      { id: "shirt", display: "\uD83D\uDC55", label: "T Shirt", color: "#4ECDC4" },
      { id: "pants", display: "\uD83D\uDC56", label: "Jeans", color: "#1E90FF" },
      { id: "dress", display: "\uD83D\uDC57", label: "Dress", color: "#FF69B4" },
      { id: "hat", display: "\uD83E\uDDE2", label: "Billed Cap", color: "#8B4513" },
      { id: "shoe", display: "\uD83D\uDC5F", label: "Running Shoe", color: "#FF6347" },
      { id: "glasses", display: "\uD83D\uDC53", label: "Glasses", color: "#2C3E50" },
      { id: "scarf", display: "\uD83E\uDDE3", label: "Scarf", color: "#E74C3C" },
      { id: "gloves", display: "\uD83E\uDDE4", label: "Gloves", color: "#D3D3D3" },
      { id: "suit", display: "\uD83E\uDD35", label: "Person In Tuxedo", color: "#2C3E50" },
      { id: "crown", display: "\uD83D\uDC51", label: "Crown", color: "#FFD700" },
      { id: "sandal", display: "\uD83E\uDE74", label: "Thong Sandal", color: "#FF8C00" },
      { id: "tie", display: "\uD83D\uDC54", label: "Necktie", color: "#DC143C" },
      { id: "socks", display: "\uD83E\uDDE6", label: "Socks", color: "#87CEEB" },
      { id: "purse", display: "\uD83D\uDC5C", label: "Handbag", color: "#8B4513" },
      { id: "backpack_c", display: "\uD83C\uDF92", label: "Backpack", color: "#FF6347" },
      { id: "ring", display: "\uD83D\uDC8D", label: "Ring", color: "#FFD700" },
      { id: "watch", display: "\u231A", label: "Watch", color: "#2C3E50" },
      { id: "belt", display: "\uD83E\uDE96", label: "Military Helmet", color: "#8B4513" },
      { id: "boot", display: "\uD83D\uDC62", label: "Woman’s Boot", color: "#8B4513" },
      { id: "cap", display: "\uD83E\uDDE5", label: "Coat", color: "#1E90FF" },
    
    
    
    
    
    
    
    ]
  },
  house: {
    name: "House",
    icon: "\uD83C\uDFE0",
    color: "#FF7043",
    cards: [
      { id: "house_h", display: "\uD83C\uDFE0", label: "House", color: "#FF7043" },
      { id: "door", display: "\uD83D\uDEAA", label: "Door", color: "#8B4513" },
      { id: "window", display: "\uD83E\uDE9F", label: "Window", color: "#87CEEB" },
      { id: "key", display: "\uD83D\uDD11", label: "Key", color: "#FFD700" },
      { id: "lamp", display: "\uD83D\uDCA1", label: "Light Bulb", color: "#FFD700" },
      { id: "sofa", display: "\uD83D\uDECB\uFE0F", label: "Couch And Lamp", color: "#8B4513" },
      { id: "tv", display: "\uD83D\uDCFA", label: "Television", color: "#2C3E50" },
      { id: "fridge", display: "\uD83E\uDDCA", label: "Ice", color: "#87CEEB" },
      { id: "shower", display: "\uD83D\uDEBF", label: "Shower", color: "#4ECDC4" },
      { id: "bed", display: "\uD83D\uDECF\uFE0F", label: "Bed", color: "#9B59B6" },
      { id: "clock", display: "\u23F0", label: "Alarm Clock", color: "#FF6347" },
      { id: "phone", display: "\uD83D\uDCDE", label: "Telephone Receiver", color: "#32CD32" },
      { id: "mirror", display: "\uD83E\uDE9E", label: "Mirror", color: "#C0C0C0" },
      { id: "candle", display: "\uD83D\uDD6F\uFE0F", label: "Candle", color: "#FFD700" },
      { id: "vase", display: "\uD83C\uDFFA", label: "Amphora", color: "#E74C3C" },
      { id: "painting", display: "\uD83D\uDDBC\uFE0F", label: "Framed Picture", color: "#9B59B6" },
      { id: "broom", display: "\uD83E\uDDF9", label: "Broom", color: "#DEB887" },
      { id: "bucket", display: "\uD83E\uDEA3", label: "Bucket", color: "#4682B4" },
      { id: "computer", display: "\uD83D\uDCBB", label: "Laptop", color: "#2C3E50" },
      { id: "toilet", display: "\uD83D\uDEBD", label: "Toilet", color: "#FFFFFF" },
    
    
    
    
    
    
    
    ]
  },
  vegetables: {
    name: "Vegetables",
    icon: "\uD83E\uDD66",
    color: "#2ECC71",
    cards: [
      { id: "carrot", display: "\uD83E\uDD55", label: "Carrot", color: "#FF8C00" },
      { id: "broccoli", display: "\uD83E\uDD66", label: "Broccoli", color: "#228B22" },
      { id: "tomato_v", display: "\uD83C\uDF45", label: "Tomato", color: "#FF6347" },
      { id: "corn", display: "\uD83C\uDF3D", label: "Ear Of Corn", color: "#FFD700" },
      { id: "eggplant", display: "\uD83C\uDF46", label: "Eggplant", color: "#6B238E" },
      { id: "pepper", display: "\uD83E\uDED1", label: "Bell Pepper", color: "#FF4500" },
      { id: "onion", display: "\uD83E\uDDC5", label: "Onion", color: "#DEB887" },
      { id: "potato", display: "\uD83E\uDD54", label: "Potato", color: "#D2B48C" },
      { id: "chili", display: "\uD83C\uDF36\uFE0F", label: "Hot Pepper", color: "#FF0000" },
      { id: "mushroom", display: "\uD83C\uDF44", label: "Mushroom", color: "#D2B48C" },
      { id: "lettuce", display: "\uD83E\uDD6C", label: "Leafy Green", color: "#32CD32" },
      { id: "peanut", display: "\uD83E\uDD5C", label: "Peanuts", color: "#DEB887" },
      { id: "garlic", display: "\uD83E\uDDC4", label: "Garlic", color: "#FFFACD" },
      { id: "cucumber", display: "\uD83E\uDD52", label: "Cucumber", color: "#228B22" },
      { id: "pumpkin", display: "\uD83C\uDF83", label: "Jack O Lantern", color: "#FF8C00" },
      { id: "spinach", display: "\uD83C\uDF43", label: "Leaf Fluttering In Wind", color: "#228B22" },
      { id: "celery", display: "\uD83C\uDF3F", label: "Herb", color: "#32CD32" },
      { id: "radish", display: "\uD83E\uDED0", label: "Blueberries", color: "#FF6B6B" },
      { id: "sweet_potato", display: "\uD83C\uDF60", label: "Roasted Sweet Potato", color: "#D2691E" },
      { id: "beans", display: "\uD83E\uDED8", label: "Beans", color: "#228B22" },
    
    
    
    
    
    
    
    ]
  },
  ocean: {
    name: "Ocean",
    icon: "\uD83C\uDF0A",
    color: "#0077B6",
    cards: [
      { id: "whale", display: "\uD83D\uDC33", label: "Spouting Whale", color: "#4682B4" },
      { id: "shark", display: "\uD83E\uDD88", label: "Shark", color: "#808080" },
      { id: "octopus", display: "\uD83D\uDC19", label: "Octopus", color: "#9B59B6" },
      { id: "crab", display: "\uD83E\uDD80", label: "Crab", color: "#FF4500" },
      { id: "shrimp", display: "\uD83E\uDD90", label: "Shrimp", color: "#FF6347" },
      { id: "jellyfish", display: "\uD83E\uDEBC", label: "Jellyfish", color: "#FF69B4" },
      { id: "seahorse", display: "\uD83D\uDC1F", label: "Fish", color: "#FFD700" },
      { id: "shell", display: "\uD83D\uDC1A", label: "Spiral Shell", color: "#FFB6C1" },
      { id: "starfish", display: "\u2B50", label: "Star", color: "#FF8C00" },
      { id: "coral", display: "\uD83E\uDEB8", label: "Coral", color: "#FF69B4" },
      { id: "wave", display: "\uD83C\uDF0A", label: "Water Wave", color: "#1E90FF" },
      { id: "anchor", display: "\u2693", label: "Anchor", color: "#2C3E50" },
      { id: "lobster", display: "\uD83E\uDD9E", label: "Lobster", color: "#DC143C" },
      { id: "seal", display: "\uD83E\uDDAD", label: "Seal", color: "#808080" },
      { id: "penguin_o", display: "\uD83D\uDC27", label: "Penguin", color: "#2C3E50" },
      { id: "tropical_fish", display: "\uD83D\uDC20", label: "Tropical Fish", color: "#FFD700" },
      { id: "blowfish", display: "\uD83D\uDC21", label: "Blowfish", color: "#4ECDC4" },
      { id: "island", display: "\uD83C\uDFDD\uFE0F", label: "Desert Island", color: "#228B22" },
      { id: "pearl", display: "\uD83E\uDEA9", label: "Mirror Ball", color: "#FFFACD" },
      { id: "trident", display: "\uD83D\uDD31", label: "Trident Emblem", color: "#FFD700" },
    
    
    
    
    
    
    
    ]
  },
  toys: {
    name: "Mainan",
    icon: "\uD83E\uDDF8",
    color: "#FF69B4",
    cards: [
      { id: "teddy", display: "\uD83E\uDDF8", label: "Teddy Bear", color: "#A0522D" },
      { id: "yoyo", display: "\uD83E\uDE80", label: "Yo Yo", color: "#FF6347" },
      { id: "kite", display: "\uD83E\uDE81", label: "Kite", color: "#1E90FF" },
      { id: "game_pad", display: "\uD83C\uDFAE", label: "Video Game", color: "#9B59B6" },
      { id: "dice", display: "\uD83C\uDFB2", label: "Game Die", color: "#FFD700" },
      { id: "darts", display: "\uD83C\uDFAF", label: "Bullseye", color: "#DC143C" },
      { id: "pinata", display: "\uD83E\uDE85", label: "Piñata", color: "#FFA500" },
      { id: "carnival", display: "\uD83C\uDFAA", label: "Circus Tent", color: "#FF69B4" },
      { id: "art_palette", display: "\uD83C\uDFA8", label: "Artist Palette", color: "#9370DB" },
      { id: "crayon", display: "\uD83D\uDD8D\uFE0F", label: "Crayon", color: "#FFD700" },
      { id: "mask", display: "\uD83C\uDFAD", label: "Performing Arts", color: "#FF1493" },
      { id: "microphone", display: "\uD83C\uDFA4", label: "Microphone", color: "#FFD700" },
      { id: "guitar", display: "\uD83C\uDFB8", label: "Guitar", color: "#A0522D" },
      { id: "trumpet", display: "\uD83C\uDFBA", label: "Trumpet", color: "#FFD700" },
      { id: "violin", display: "\uD83C\uDFBB", label: "Violin", color: "#8B4513" },
      { id: "keyboard_music", display: "\uD83C\uDFB9", label: "Musical Keyboard", color: "#2C3E50" },
      { id: "longdrum", display: "\uD83E\uDED8", label: "Beans", color: "#FF8C00" },
      { id: "drum", display: "\uD83E\uDD41", label: "Drum", color: "#DC143C" },
      { id: "saxophone", display: "\uD83C\uDFB7", label: "Saxophone", color: "#FFD700" },
      { id: "book_toy", display: "\uD83D\uDCDA", label: "Books", color: "#4ECDC4" },
    
    
    
    
    
    
    
    ]
  },
  drinks: {
    name: "Minuman",
    icon: "\uD83E\uDD64",
    color: "#1E90FF",
    cards: [
      { id: "milk", display: "\uD83E\uDD5B", label: "Glass Of Milk", color: "#FFFAF0" },
      { id: "bubble_tea", display: "\uD83E\uDDCB", label: "Bubble Tea", color: "#8B4513" },
      { id: "tea", display: "\uD83C\uDF75", label: "Teacup Without Handle", color: "#228B22" },
      { id: "coffee", display: "\u2615", label: "Hot Beverage", color: "#8B4513" },
      { id: "cup_straw", display: "\uD83E\uDD64", label: "Cup With Straw", color: "#FF6347" },
      { id: "juice", display: "\uD83E\uDDC3", label: "Beverage Box", color: "#FFA500" },
      { id: "tropical_drink", display: "\uD83C\uDF79", label: "Tropical Drink", color: "#FF69B4" },
      { id: "cocktail", display: "\uD83C\uDF78", label: "Cocktail Glass", color: "#FF1493" },
      { id: "wine", display: "\uD83C\uDF77", label: "Wine Glass", color: "#722F37" },
      { id: "sake", display: "\uD83C\uDF76", label: "Sake", color: "#F5DEB3" },
      { id: "mate", display: "\uD83E\uDDC9", label: "Mate", color: "#228B22" },
      { id: "beer", display: "\uD83C\uDF7A", label: "Beer Mug", color: "#FFD700" },
      { id: "beers", display: "\uD83C\uDF7B", label: "Clinking Beer Mugs", color: "#FFD700" },
      { id: "champagne", display: "\uD83C\uDF7E", label: "Bottle With Popping Cork", color: "#FFD700" },
      { id: "clinking_glass", display: "\uD83E\uDD42", label: "Clinking Glasses", color: "#FFD700" },
      { id: "ice", display: "\uD83E\uDDCA", label: "Ice", color: "#87CEEB" },
      { id: "water_drop", display: "\uD83D\uDCA7", label: "Droplet", color: "#1E90FF" },
      { id: "coconut", display: "\uD83E\uDD65", label: "Coconut", color: "#8B4513" },
      { id: "baby_bottle", display: "\uD83C\uDF7C", label: "Baby Bottle", color: "#FFB6C1" },
      { id: "teapot", display: "\uD83E\uDED6", label: "Teapot", color: "#A0522D" },
    
    
    
    
    
    
    
    ]
  },
  farm: {
    name: "Peternakan",
    icon: "\uD83D\uDC04",
    color: "#8B4513",
    cards: [
      { id: "cow_farm", display: "\uD83D\uDC04", label: "Cow", color: "#A0522D" },
      { id: "pig_farm", display: "\uD83D\uDC16", label: "Pig", color: "#FFB6C1" },
      { id: "sheep_farm", display: "\uD83D\uDC11", label: "Ewe", color: "#FFFAF0" },
      { id: "rooster", display: "\uD83D\uDC13", label: "Rooster", color: "#DC143C" },
      { id: "chicken_farm", display: "\uD83D\uDC14", label: "Chicken", color: "#FFD700" },
      { id: "horse_farm", display: "\uD83D\uDC0E", label: "Horse", color: "#8B4513" },
      { id: "goat_farm", display: "\uD83D\uDC10", label: "Goat", color: "#A0522D" },
      { id: "turkey", display: "\uD83E\uDD83", label: "Turkey", color: "#8B0000" },
      { id: "rabbit_farm", display: "\uD83D\uDC07", label: "Rabbit", color: "#FFFAF0" },
      { id: "cat_farm", display: "\uD83D\uDC08", label: "Cat", color: "#FFA500" },
      { id: "dog_farm", display: "\uD83D\uDC15", label: "Dog", color: "#8B4513" },
      { id: "duck", display: "\uD83E\uDD86", label: "Duck", color: "#FFD700" },
      { id: "goose", display: "\uD83E\uDEBF", label: "Goose", color: "#FFFAF0" },
      { id: "mouse_farm", display: "\uD83D\uDC01", label: "Mouse", color: "#808080" },
      { id: "tractor", display: "\uD83D\uDE9C", label: "Tractor", color: "#FF4500" },
      { id: "wheat", display: "\uD83C\uDF3E", label: "Sheaf Of Rice", color: "#DAA520" },
      { id: "egg", display: "\uD83E\uDD5A", label: "Egg", color: "#FFFAF0" },
      { id: "fried_egg", display: "\uD83C\uDF73", label: "Cooking", color: "#FFD700" },
      { id: "carrot_farm", display: "\uD83E\uDD55", label: "Carrot", color: "#FF8C00" },
      { id: "bee", display: "\uD83D\uDC1D", label: "Honeybee", color: "#FFD700" },
    
    
    
    
    
    
    
    ]
  },
  family: {
    name: "Keluarga",
    icon: "\uD83D\uDC6A",
    color: "#FF69B4",
    cards: [
      { id: "man_fam", display: "\uD83D\uDC68", label: "Man", color: "#4682B4" },
      { id: "woman_fam", display: "\uD83D\uDC69", label: "Woman", color: "#FF69B4" },
      { id: "boy_fam", display: "\uD83D\uDC66", label: "Boy", color: "#1E90FF" },
      { id: "girl_fam", display: "\uD83D\uDC67", label: "Girl", color: "#FFB6C1" },
      { id: "baby", display: "\uD83D\uDC76", label: "Baby", color: "#FFE4B5" },
      { id: "older_person", display: "\uD83E\uDDD3", label: "Older Person", color: "#A9A9A9" },
      { id: "child", display: "\uD83E\uDDD2", label: "Child", color: "#FFA500" },
      { id: "family_4", display: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66", label: "Family Man Woman Girl Boy", color: "#FF1493" },
      { id: "family_3", display: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67", label: "Family Man Woman Girl", color: "#FF69B4" },
      { id: "heart_fam", display: "\u2764\uFE0F", label: "Red Heart", color: "#DC143C" },
      { id: "hug", display: "\uD83E\uDEC2", label: "People Hugging", color: "#FFB6C1" },
      { id: "couple_w", display: "\uD83D\uDC6B", label: "Woman And Man Holding Hands", color: "#FF69B4" },
      { id: "men_holding", display: "\uD83D\uDC6C", label: "Men Holding Hands", color: "#1E90FF" },
      { id: "women_holding", display: "\uD83D\uDC6D", label: "Women Holding Hands", color: "#FF69B4" },
      { id: "feeding_dad", display: "\uD83D\uDC68\u200D\uD83C\uDF7C", label: "Man Feeding Baby", color: "#4682B4" },
      { id: "feeding_mom", display: "\uD83D\uDC69\u200D\uD83C\uDF7C", label: "Woman Feeding Baby", color: "#FF69B4" },
      { id: "people_holding", display: "\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1", label: "People Holding Hands", color: "#FFD700" },
      { id: "wedding", display: "\uD83D\uDC91", label: "Couple With Heart", color: "#FF1493" },
      { id: "pregnant", display: "\uD83E\uDD30", label: "Pregnant Woman", color: "#FFB6C1" },
      { id: "baby_symbol", display: "\uD83D\uDEBC", label: "Baby Symbol", color: "#87CEEB" },
    
    
    
    
    
    
    
    ]
  },
  birds: {
    name: "Burung",
    icon: "\uD83D\uDC26",
    color: "#1E90FF",
    cards: [
      { id: "eagle_b", display: "\uD83E\uDD85", label: "Eagle", color: "#8B4513" },
      { id: "duck_b", display: "\uD83E\uDD86", label: "Duck", color: "#FFD700" },
      { id: "owl_b", display: "\uD83E\uDD89", label: "Owl", color: "#8B4513" },
      { id: "bird_b", display: "\uD83D\uDC26", label: "Bird", color: "#1E90FF" },
      { id: "penguin_b", display: "\uD83D\uDC27", label: "Penguin", color: "#2C3E50" },
      { id: "parrot", display: "\uD83E\uDD9C", label: "Parrot", color: "#228B22" },
      { id: "flamingo", display: "\uD83E\uDDA9", label: "Flamingo", color: "#FF69B4" },
      { id: "peacock", display: "\uD83E\uDD9A", label: "Peacock", color: "#1E90FF" },
      { id: "swan", display: "\uD83E\uDDA2", label: "Swan", color: "#FFFAF0" },
      { id: "baby_chick", display: "\uD83D\uDC24", label: "Baby Chick", color: "#FFD700" },
      { id: "front_chick", display: "\uD83D\uDC25", label: "Front Facing Baby Chick", color: "#FFD700" },
      { id: "hatching_chick", display: "\uD83D\uDC23", label: "Hatching Chick", color: "#FFD700" },
      { id: "turkey_b", display: "\uD83E\uDD83", label: "Turkey", color: "#8B0000" },
      { id: "feather", display: "\uD83E\uDEB6", label: "Feather", color: "#A9A9A9" },
      { id: "rooster_b", display: "\uD83D\uDC13", label: "Rooster", color: "#DC143C" },
      { id: "chicken_b", display: "\uD83D\uDC14", label: "Chicken", color: "#FFD700" },
      { id: "dove", display: "\uD83D\uDD4A\uFE0F", label: "Dove", color: "#FFFAF0" },
      { id: "dodo", display: "\uD83E\uDD64\uFE0F", label: "Cup With Straw", color: "#FFD700" },
      { id: "bat_b", display: "\uD83E\uDD87", label: "Bat", color: "#2C3E50" },
      { id: "goose_b", display: "\uD83E\uDEBF", label: "Goose", color: "#FFFAF0" },
    
    
    
    
    
    
    
    ]
  },
  camping: {
    name: "Berkemah",
    icon: "\uD83C\uDFD5\uFE0F",
    color: "#228B22",
    cards: [
      { id: "camping_site", display: "\uD83C\uDFD5\uFE0F", label: "Camping", color: "#228B22" },
      { id: "tent", display: "\u26FA", label: "Tent", color: "#FF8C00" },
      { id: "fire", display: "\uD83D\uDD25", label: "Fire", color: "#FF4500" },
      { id: "mountain", display: "\uD83C\uDFD4\uFE0F", label: "Snow Capped Mountain", color: "#808080" },
      { id: "evergreen", display: "\uD83C\uDF32", label: "Evergreen Tree", color: "#228B22" },
      { id: "tree_c", display: "\uD83C\uDF33", label: "Deciduous Tree", color: "#228B22" },
      { id: "palm_tree", display: "\uD83C\uDF34", label: "Palm Tree", color: "#228B22" },
      { id: "hiking_boot", display: "\uD83E\uDD7E", label: "Hiking Boot", color: "#8B4513" },
      { id: "backpack", display: "\uD83C\uDF92", label: "Backpack", color: "#FF4500" },
      { id: "compass", display: "\uD83E\uDDED", label: "Compass", color: "#FFD700" },
      { id: "map", display: "\uD83D\uDDFA\uFE0F", label: "World Map", color: "#DEB887" },
      { id: "wood", display: "\uD83E\uDEB5", label: "Wood", color: "#8B4513" },
      { id: "fishing", display: "\uD83C\uDFA3", label: "Fishing Pole", color: "#1E90FF" },
      { id: "deer", display: "\uD83E\uDD8C", label: "Deer", color: "#8B4513" },
      { id: "bear", display: "\uD83D\uDC3B", label: "Bear", color: "#8B4513" },
      { id: "milky_way", display: "\uD83C\uDF0C", label: "Milky Way", color: "#4B0082" },
      { id: "star_c", display: "\u2B50", label: "Star", color: "#FFD700" },
      { id: "moon_c", display: "\uD83C\uDF19", label: "Crescent Moon", color: "#FFD700" },
      { id: "axe", display: "\uD83E\uDE93", label: "Axe", color: "#A9A9A9" },
      { id: "binoculars", display: "\uD83D\uDD2D", label: "Telescope", color: "#2C3E50" },
    
    
    
    
    
    
    
    ]
  },
  holidays: {
    name: "Liburan",
    icon: "\uD83C\uDF89",
    color: "#FF1493",
    cards: [
      { id: "party_popper", display: "\uD83C\uDF89", label: "Party Popper", color: "#FF1493" },
      { id: "confetti_ball", display: "\uD83C\uDF8A", label: "Confetti Ball", color: "#FFD700" },
      { id: "cake_holi", display: "\uD83C\uDF82", label: "Birthday Cake", color: "#FF69B4" },
      { id: "gift", display: "\uD83C\uDF81", label: "Wrapped Gift", color: "#DC143C" },
      { id: "balloon", display: "\uD83D\uDEFA", label: "Auto Rickshaw", color: "#FF6347" },
      { id: "christmas_tree", display: "\uD83C\uDF84", label: "Christmas Tree", color: "#228B22" },
      { id: "pumpkin", display: "\uD83C\uDF83", label: "Jack O Lantern", color: "#FF8C00" },
      { id: "ribbon", display: "\uD83C\uDF80", label: "Ribbon", color: "#FF1493" },
      { id: "disco", display: "\uD83E\uDEA9", label: "Mirror Ball", color: "#9B59B6" },
      { id: "sparkler", display: "\uD83C\uDF87", label: "Sparkler", color: "#FFD700" },
      { id: "fireworks", display: "\uD83C\uDF86", label: "Fireworks", color: "#FF1493" },
      { id: "beach", display: "\uD83C\uDFD6\uFE0F", label: "Beach With Umbrella", color: "#FFD700" },
      { id: "airplane", display: "\u2708\uFE0F", label: "Airplane", color: "#1E90FF" },
      { id: "luggage", display: "\uD83E\uDDF3", label: "Luggage", color: "#8B4513" },
      { id: "tropical_island", display: "\uD83C\uDFDD\uFE0F", label: "Desert Island", color: "#228B22" },
      { id: "statue", display: "\uD83D\uDDFD", label: "Statue Of Liberty", color: "#228B22" },
      { id: "tokyo_tower", display: "\uD83D\uDDFC", label: "Tokyo Tower", color: "#DC143C" },
      { id: "castle", display: "\uD83C\uDFF0", label: "Castle", color: "#A9A9A9" },
      { id: "carousel", display: "\uD83C\uDFA0", label: "Carousel Horse", color: "#FF69B4" },
      { id: "ferris", display: "\uD83C\uDFA1", label: "Ferris Wheel", color: "#FF1493" },
    
    
    
    
    
    
    
    ]
  },
  tools: {
    name: "Alat",
    icon: "\uD83D\uDD27",
    color: "#A9A9A9",
    cards: [
      { id: "hammer", display: "\uD83D\uDD28", label: "Hammer", color: "#8B4513" },
      { id: "screwdriver", display: "\uD83E\uDE9B", label: "Screwdriver", color: "#FFD700" },
      { id: "wrench", display: "\uD83D\uDD27", label: "Wrench", color: "#A9A9A9" },
      { id: "gear", display: "\u2699\uFE0F", label: "Gear", color: "#808080" },
      { id: "saw", display: "\uD83E\uDE9A", label: "Carpentry Saw", color: "#A9A9A9" },
      { id: "ladder", display: "\uD83E\uDE9C", label: "Ladder", color: "#8B4513" },
      { id: "toolbox", display: "\uD83E\uDDF0", label: "Toolbox", color: "#FF4500" },
      { id: "nut_bolt", display: "\uD83D\uDD29", label: "Nut And Bolt", color: "#A9A9A9" },
      { id: "axe_t", display: "\uD83E\uDE93", label: "Axe", color: "#A9A9A9" },
      { id: "ruler", display: "\uD83D\uDCCF", label: "Straight Ruler", color: "#FFD700" },
      { id: "triangle_ruler", display: "\uD83D\uDCD0", label: "Triangular Ruler", color: "#1E90FF" },
      { id: "scissors", display: "\u2702\uFE0F", label: "Scissors", color: "#DC143C" },
      { id: "pen", display: "\uD83D\uDD8A\uFE0F", label: "Pen", color: "#2C3E50" },
      { id: "paintbrush", display: "\uD83D\uDD8C\uFE0F", label: "Paintbrush", color: "#8B4513" },
      { id: "crayon_t", display: "\uD83D\uDD8D\uFE0F", label: "Crayon", color: "#FFD700" },
      { id: "test_tube", display: "\uD83E\uDDEA", label: "Test Tube", color: "#1E90FF" },
      { id: "microscope", display: "\uD83D\uDD2C", label: "Microscope", color: "#2C3E50" },
      { id: "telescope", display: "\uD83D\uDD2D", label: "Telescope", color: "#2C3E50" },
      { id: "scale", display: "\u2696\uFE0F", label: "Balance Scale", color: "#FFD700" },
      { id: "magnet", display: "\uD83E\uDDF2", label: "Magnet", color: "#DC143C" },
    
    
    
    
    
    
    
    ]
  },
  kitchen: {
    name: "Dapur",
    icon: "\uD83C\uDF73",
    color: "#FF8C00",
    cards: [
      { id: "fork_knife", display: "\uD83C\uDF74", label: "Fork And Knife", color: "#A9A9A9" },
      { id: "spoon", display: "\uD83E\uDD44", label: "Spoon", color: "#A9A9A9" },
      { id: "kitchen_knife", display: "\uD83D\uDD2A", label: "Kitchen Knife", color: "#A9A9A9" },
      { id: "cooking", display: "\uD83C\uDF73", label: "Cooking", color: "#FFD700" },
      { id: "pan", display: "\uD83E\uDD58", label: "Shallow Pan Of Food", color: "#A9A9A9" },
      { id: "plate", display: "\uD83C\uDF7D\uFE0F", label: "Fork And Knife With Plate", color: "#FFFAF0" },
      { id: "bowl", display: "\uD83E\uDD63", label: "Bowl With Spoon", color: "#FFA500" },
      { id: "chopsticks", display: "\uD83E\uDD62", label: "Chopsticks", color: "#8B4513" },
      { id: "salt", display: "\uD83E\uDDC2", label: "Salt", color: "#FFFAF0" },
      { id: "pour", display: "\uD83E\uDED7", label: "Pouring Liquid", color: "#1E90FF" },
      { id: "ice_kit", display: "\uD83E\uDDCA", label: "Ice", color: "#87CEEB" },
      { id: "butter", display: "\uD83E\uDDC8", label: "Butter", color: "#FFD700" },
      { id: "takeout", display: "\uD83E\uDD61", label: "Takeout Box", color: "#FF8C00" },
      { id: "extinguisher", display: "\uD83E\uDDEF", label: "Fire Extinguisher", color: "#DC143C" },
      { id: "avocado_kit", display: "\uD83E\uDD51", label: "Avocado", color: "#228B22" },
      { id: "onion", display: "\uD83E\uDDC5", label: "Onion", color: "#FF69B4" },
      { id: "canned", display: "\uD83E\uDD6B", label: "Canned Food", color: "#A9A9A9" },
      { id: "bucket", display: "\uD83E\uDEA3", label: "Bucket", color: "#FFD700" },
      { id: "pot_food", display: "\uD83C\uDF72", label: "Pot Of Food", color: "#FF8C00" },
      { id: "amphora", display: "\uD83C\uDFFA", label: "Amphora", color: "#8B4513" },
    
    
    
    
    
    
    
    ]
  },
  flowers: {
    name: "Bunga",
    icon: "\uD83C\uDF38",
    color: "#FF1493",
    cards: [
      { id: "rose", display: "\uD83C\uDF39", label: "Rose", color: "#DC143C" },
      { id: "tulip", display: "\uD83C\uDF37", label: "Tulip", color: "#FF1493" },
      { id: "sunflower", display: "\uD83C\uDF3B", label: "Sunflower", color: "#FFD700" },
      { id: "cherry_blossom", display: "\uD83C\uDF38", label: "Cherry Blossom", color: "#FFB6C1" },
      { id: "hibiscus", display: "\uD83C\uDF3A", label: "Hibiscus", color: "#FF69B4" },
      { id: "blossom", display: "\uD83C\uDF3C", label: "Blossom", color: "#FFD700" },
      { id: "bouquet", display: "\uD83D\uDC90", label: "Bouquet", color: "#FF69B4" },
      { id: "hyacinth", display: "\uD83E\uDEBB", label: "Hyacinth", color: "#9370DB" },
      { id: "lotus", display: "\uD83E\uDEB7", label: "Lotus", color: "#FFB6C1" },
      { id: "herb", display: "\uD83C\uDF3F", label: "Herb", color: "#228B22" },
      { id: "clover", display: "\uD83C\uDF40", label: "Four Leaf Clover", color: "#228B22" },
      { id: "seedling", display: "\uD83C\uDF31", label: "Seedling", color: "#228B22" },
      { id: "rice_plant", display: "\uD83C\uDF3E", label: "Sheaf Of Rice", color: "#DAA520" },
      { id: "potted", display: "\uD83E\uDEB4", label: "Potted Plant", color: "#228B22" },
      { id: "cactus", display: "\uD83C\uDF35", label: "Cactus", color: "#228B22" },
      { id: "palm_f", display: "\uD83C\uDF34", label: "Palm Tree", color: "#228B22" },
      { id: "maple", display: "\uD83C\uDF41", label: "Maple Leaf", color: "#DC143C" },
      { id: "fallen_leaf", display: "\uD83C\uDF42", label: "Fallen Leaf", color: "#FF8C00" },
      { id: "leaf_wind", display: "\uD83C\uDF43", label: "Leaf Fluttering In Wind", color: "#228B22" },
      { id: "tree_f", display: "\uD83C\uDF33", label: "Deciduous Tree", color: "#228B22" },
    
    
    
    
    
    
    
    ]
  },
  desserts: {
    name: "Kue & Manisan",
    icon: "\uD83C\uDF70",
    color: "#FF69B4",
    cards: [
      { id: "cake", display: "\uD83C\uDF70", label: "Shortcake", color: "#FFB6C1" },
      { id: "shortcake", display: "\uD83C\uDF82", label: "Birthday Cake", color: "#FF69B4" },
      { id: "cupcake", display: "\uD83E\uDDC1", label: "Cupcake", color: "#FF1493" },
      { id: "cookie", display: "\uD83C\uDF6A", label: "Cookie", color: "#8B4513" },
      { id: "doughnut", display: "\uD83C\uDF69", label: "Doughnut", color: "#FF69B4" },
      { id: "lollipop", display: "\uD83C\uDF6D", label: "Lollipop", color: "#FF1493" },
      { id: "candy", display: "\uD83C\uDF6C", label: "Candy", color: "#FF69B4" },
      { id: "chocolate", display: "\uD83C\uDF6B", label: "Chocolate Bar", color: "#8B4513" },
      { id: "icecream", display: "\uD83C\uDF66", label: "Soft Ice Cream", color: "#FFFAF0" },
      { id: "shaved_ice", display: "\uD83C\uDF67", label: "Shaved Ice", color: "#87CEEB" },
      { id: "ice_cream_yellow", display: "\uD83C\uDF68", label: "Ice Cream", color: "#FFD700" },
      { id: "honey", display: "\uD83C\uDF6F", label: "Honey Pot", color: "#FFD700" },
      { id: "pudding", display: "\uD83C\uDF6E", label: "Custard", color: "#FFD700" },
      { id: "pie", display: "\uD83E\uDD67", label: "Pie", color: "#FF8C00" },
      { id: "moon_cake", display: "\uD83E\uDD6E", label: "Moon Cake", color: "#FFD700" },
      { id: "pancakes", display: "\uD83E\uDD5E", label: "Pancakes", color: "#FFD700" },
      { id: "waffle", display: "\uD83E\uDDC7", label: "Waffle", color: "#FFD700" },
      { id: "tea_d", display: "\uD83C\uDF75", label: "Teacup Without Handle", color: "#228B22" },
      { id: "milkshake", display: "\uD83E\uDD5B", label: "Glass Of Milk", color: "#FFFAF0" },
      { id: "fortune_cookie", display: "\uD83E\uDD60", label: "Fortune Cookie", color: "#FFD700" },
    
    
    
    
    
    
    
    ]
  },
  instruments: {
    name: "Alat Musik",
    icon: "\uD83C\uDFB9",
    color: "#9B59B6",
    cards: [
      { id: "piano", display: "\uD83C\uDFB9", label: "Musical Keyboard", color: "#2C3E50" },
      { id: "drum_i", display: "\uD83E\uDD41", label: "Drum", color: "#DC143C" },
      { id: "guitar_i", display: "\uD83C\uDFB8", label: "Guitar", color: "#A0522D" },
      { id: "violin_i", display: "\uD83C\uDFBB", label: "Violin", color: "#8B4513" },
      { id: "trumpet_i", display: "\uD83C\uDFBA", label: "Trumpet", color: "#FFD700" },
      { id: "saxophone_i", display: "\uD83C\uDFB7", label: "Saxophone", color: "#FFD700" },
      { id: "accordion", display: "\uD83E\uDE97", label: "Accordion", color: "#DC143C" },
      { id: "banjo", display: "\uD83E\uDE95", label: "Banjo", color: "#A0522D" },
      { id: "long_drum", display: "\uD83E\uDED8", label: "Beans", color: "#FF8C00" },
      { id: "maracas", display: "\uD83E\uDE87", label: "Maracas", color: "#FFD700" },
      { id: "flute", display: "\uD83E\uDE88", label: "Flute", color: "#C0C0C0" },
      { id: "harp", display: "\uD83E\uDE89", label: "Harp", color: "#FFD700" },
      { id: "musical_note", display: "\uD83C\uDFB5", label: "Musical Note", color: "#9B59B6" },
      { id: "musical_notes", display: "\uD83C\uDFB6", label: "Musical Notes", color: "#9B59B6" },
      { id: "microphone_i", display: "\uD83C\uDFA4", label: "Microphone", color: "#FFD700" },
      { id: "headphone", display: "\uD83C\uDFA7", label: "Headphone", color: "#2C3E50" },
      { id: "studio_mic", display: "\uD83C\uDF99\uFE0F", label: "Studio Microphone", color: "#A9A9A9" },
      { id: "speaker", display: "\uD83D\uDD08", label: "Speaker Low Volume", color: "#2C3E50" },
      { id: "level_slider", display: "\uD83C\uDF9A\uFE0F", label: "Level Slider", color: "#A9A9A9" },
      { id: "control_knob", display: "\uD83C\uDF9B\uFE0F", label: "Control Knobs", color: "#A9A9A9" },
    
    
    
    
    
    
    
    ]
  },
  beach: {
    name: "Pantai",
    icon: "\uD83C\uDFD6\uFE0F",
    color: "#1E90FF",
    cards: [
      { id: "beach_b", display: "\uD83C\uDFD6\uFE0F", label: "Beach With Umbrella", color: "#FFD700" },
      { id: "umbrella_b", display: "\u26F1\uFE0F", label: "Umbrella On Ground", color: "#FF1493" },
      { id: "sun_b", display: "\u2600\uFE0F", label: "Sun", color: "#FFD700" },
      { id: "wave_b", display: "\uD83C\uDF0A", label: "Water Wave", color: "#1E90FF" },
      { id: "palm_b", display: "\uD83C\uDF34", label: "Palm Tree", color: "#228B22" },
      { id: "shell_b", display: "\uD83D\uDC1A", label: "Spiral Shell", color: "#FFB6C1" },
      { id: "crab_b", display: "\uD83E\uDD80", label: "Crab", color: "#FF4500" },
      { id: "surfer", display: "\uD83C\uDFC4", label: "Person Surfing", color: "#1E90FF" },
      { id: "swimmer", display: "\uD83C\uDFCA", label: "Person Swimming", color: "#4682B4" },
      { id: "swimsuit", display: "\uD83D\uDC59", label: "Bikini", color: "#FF69B4" },
      { id: "thong_sandal", display: "\uD83E\uDE74", label: "Thong Sandal", color: "#FF8C00" },
      { id: "sunglasses_b", display: "\uD83D\uDD76\uFE0F", label: "Sunglasses", color: "#2C3E50" },
      { id: "watermelon_b", display: "\uD83C\uDF49", label: "Watermelon", color: "#DC143C" },
      { id: "icecream_b", display: "\uD83C\uDF66", label: "Soft Ice Cream", color: "#FFFAF0" },
      { id: "drink_b", display: "\uD83C\uDF79", label: "Tropical Drink", color: "#FF69B4" },
      { id: "coconut_b", display: "\uD83E\uDD65", label: "Coconut", color: "#8B4513" },
      { id: "boat", display: "\u26F5", label: "Sailboat", color: "#FFFAF0" },
      { id: "ship", display: "\uD83D\uDEA2", label: "Ship", color: "#4682B4" },
      { id: "lighthouse", display: "\uD83D\uDDFC", label: "Tokyo Tower", color: "#DC143C" },
      { id: "island_b", display: "\uD83C\uDFDD\uFE0F", label: "Desert Island", color: "#228B22" },
    
    
    
    
    
    
    
    ]
  },
  tech: {
    name: "Teknologi",
    icon: "\uD83E\uDD16",
    color: "#4ECDC4",
    cards: [
      { id: "robot", display: "\uD83E\uDD16", label: "Robot", color: "#A9A9A9" },
      { id: "computer", display: "\uD83D\uDCBB", label: "Laptop", color: "#2C3E50" },
      { id: "phone_t", display: "\uD83D\uDCF1", label: "Mobile Phone", color: "#1E90FF" },
      { id: "tablet", display: "\uD83D\uDCF2", label: "Mobile Phone With Arrow", color: "#2C3E50" },
      { id: "keyboard_t", display: "\u2328\uFE0F", label: "Keyboard", color: "#A9A9A9" },
      { id: "mouse_t", display: "\uD83D\uDDB1\uFE0F", label: "Computer Mouse", color: "#A9A9A9" },
      { id: "tv", display: "\uD83D\uDCFA", label: "Television", color: "#2C3E50" },
      { id: "camera_t", display: "\uD83D\uDCF7", label: "Camera", color: "#2C3E50" },
      { id: "video_camera", display: "\uD83D\uDCF9", label: "Video Camera", color: "#2C3E50" },
      { id: "printer", display: "\uD83D\uDDA8\uFE0F", label: "Printer", color: "#A9A9A9" },
      { id: "satellite", display: "\uD83D\uDCE1", label: "Satellite Antenna", color: "#A9A9A9" },
      { id: "battery", display: "\uD83D\uDD0B", label: "Battery", color: "#228B22" },
      { id: "plug", display: "\uD83D\uDD0C", label: "Electric Plug", color: "#FFD700" },
      { id: "bulb", display: "\uD83D\uDCA1", label: "Light Bulb", color: "#FFD700" },
      { id: "flashlight", display: "\uD83D\uDD26", label: "Flashlight", color: "#FFD700" },
      { id: "joystick", display: "\uD83D\uDD79\uFE0F", label: "Joystick", color: "#DC143C" },
      { id: "gamepad", display: "\uD83C\uDFAE", label: "Video Game", color: "#9B59B6" },
      { id: "abacus", display: "\uD83E\uDDEE", label: "Abacus", color: "#DC143C" },
      { id: "disc", display: "\uD83D\uDCBF", label: "Optical Disk", color: "#C0C0C0" },
      { id: "floppy", display: "\uD83D\uDCBE", label: "Floppy Disk", color: "#2C3E50" },
    
    
    
    
    
    
    
    ]
  },
  gemstones: {
    name: "Permata",
    icon: "\uD83D\uDC8E",
    color: "#9370DB",
    cards: [
      { id: "diamond", display: "\uD83D\uDC8E", label: "Gem Stone", color: "#87CEEB" },
      { id: "ring", display: "\uD83D\uDC8D", label: "Ring", color: "#FFD700" },
      { id: "crown", display: "\uD83D\uDC51", label: "Crown", color: "#FFD700" },
      { id: "prayer_beads", display: "\uD83D\uDCFF", label: "Prayer Beads", color: "#9370DB" },
      { id: "sparkles", display: "\u2728", label: "Sparkles", color: "#FFD700" },
      { id: "star_g", display: "\u2B50", label: "Star", color: "#FFD700" },
      { id: "glowing_star", display: "\uD83C\uDF1F", label: "Glowing Star", color: "#FFD700" },
      { id: "dizzy", display: "\uD83D\uDCAB", label: "Dizzy", color: "#FFD700" },
      { id: "trophy", display: "\uD83C\uDFC6", label: "Trophy", color: "#FFD700" },
      { id: "first_medal", display: "\uD83E\uDD47", label: "1st Place Medal", color: "#FFD700" },
      { id: "second_medal", display: "\uD83E\uDD48", label: "2nd Place Medal", color: "#C0C0C0" },
      { id: "third_medal", display: "\uD83E\uDD49", label: "3rd Place Medal", color: "#CD7F32" },
      { id: "medal", display: "\uD83C\uDFC5", label: "Sports Medal", color: "#FFD700" },
      { id: "military_medal", display: "\uD83C\uDF96\uFE0F", label: "Military Medal", color: "#FFD700" },
      { id: "small_diamond", display: "\uD83D\uDD39", label: "Small Blue Diamond", color: "#1E90FF" },
      { id: "blue_diamond", display: "\uD83D\uDD37", label: "Large Blue Diamond", color: "#1E90FF" },
      { id: "fleur", display: "\u269C\uFE0F", label: "Fleur De Lis", color: "#FFD700" },
      { id: "rosette", display: "\uD83C\uDFF5\uFE0F", label: "Rosette", color: "#DC143C" },
      { id: "trident_g", display: "\uD83D\uDD31", label: "Trident Emblem", color: "#FFD700" },
      { id: "coin", display: "\uD83E\uDE99", label: "Coin", color: "#FFD700" },
    
    
    
    
    
    
    
    ]
  },
  time: {
    name: "Jam & Waktu",
    icon: "\u23F0",
    color: "#FF8C00",
    cards: [
      { id: "clock_1", display: "\uD83D\uDD50", label: "1 O'clock", color: "#FF8C00" },
      { id: "clock_2", display: "\uD83D\uDD51", label: "2 O'clock", color: "#FF6347" },
      { id: "clock_3", display: "\uD83D\uDD52", label: "3 O'clock", color: "#FFD700" },
      { id: "clock_4", display: "\uD83D\uDD53", label: "4 O'clock", color: "#FF4500" },
      { id: "clock_5", display: "\uD83D\uDD54", label: "5 O'clock", color: "#FFA500" },
      { id: "clock_6", display: "\uD83D\uDD55", label: "6 O'clock", color: "#DC143C" },
      { id: "clock_7", display: "\uD83D\uDD56", label: "7 O'clock", color: "#FF8C00" },
      { id: "clock_8", display: "\uD83D\uDD57", label: "8 O'clock", color: "#FF6347" },
      { id: "clock_9", display: "\uD83D\uDD58", label: "9 O'clock", color: "#FFD700" },
      { id: "clock_10", display: "\uD83D\uDD59", label: "10 O'clock", color: "#FF4500" },
      { id: "clock_11", display: "\uD83D\uDD5A", label: "11 O'clock", color: "#FFA500" },
      { id: "clock_12", display: "\uD83D\uDD5B", label: "12 O'clock", color: "#DC143C" },
      { id: "alarm_clock", display: "\u23F0", label: "Alarm Clock", color: "#FFD700" },
      { id: "stopwatch", display: "\u23F1\uFE0F", label: "Stopwatch", color: "#A9A9A9" },
      { id: "timer_clock", display: "\u23F2\uFE0F", label: "Timer Clock", color: "#FF1493" },
      { id: "mantelpiece", display: "\uD83D\uDD70\uFE0F", label: "Mantelpiece Clock", color: "#8B4513" },
      { id: "hourglass_done", display: "\u231B", label: "Hourglass Done", color: "#DAA520" },
      { id: "hourglass_flowing", display: "\u23F3", label: "Hourglass Flowing", color: "#DAA520" },
      { id: "watch_t", display: "\u231A", label: "Wristwatch", color: "#FFD700" },
      { id: "calendar_t", display: "\uD83D\uDCC5", label: "Calendar", color: "#DC143C" },
    ]
  },
  buildings: {
    name: "Gedung",
    icon: "\uD83C\uDFE2",
    color: "#4682B4",
    cards: [
      { id: "house_b", display: "\uD83C\uDFE0", label: "House", color: "#FFA500" },
      { id: "house_garden_b", display: "\uD83C\uDFE1", label: "House With Garden", color: "#228B22" },
      { id: "office_b", display: "\uD83C\uDFE2", label: "Office Building", color: "#A9A9A9" },
      { id: "post_jp_b", display: "\uD83C\uDFE3", label: "Japanese Post Office", color: "#FF8C00" },
      { id: "post_eu_b", display: "\uD83C\uDFE4", label: "Post Office", color: "#DC143C" },
      { id: "hospital_b", display: "\uD83C\uDFE5", label: "Hospital", color: "#FFFAF0" },
      { id: "bank_b", display: "\uD83C\uDFE6", label: "Bank", color: "#FFD700" },
      { id: "hotel_b", display: "\uD83C\uDFE8", label: "Hotel", color: "#FFA500" },
      { id: "love_hotel_b", display: "\uD83C\uDFE9", label: "Love Hotel", color: "#FF69B4" },
      { id: "convenience_b", display: "\uD83C\uDFEA", label: "Convenience Store", color: "#1E90FF" },
      { id: "school_b", display: "\uD83C\uDFEB", label: "School", color: "#DC143C" },
      { id: "dept_store_b", display: "\uD83C\uDFEC", label: "Department Store", color: "#FFB6C1" },
      { id: "factory_b", display: "\uD83C\uDFED", label: "Factory", color: "#A9A9A9" },
      { id: "castle_jp_b", display: "\uD83C\uDFEF", label: "Japanese Castle", color: "#8B4513" },
      { id: "castle_eu_b", display: "\uD83C\uDFF0", label: "Castle", color: "#A9A9A9" },
      { id: "wedding_b", display: "\uD83D\uDC92", label: "Wedding Chapel", color: "#FFB6C1" },
      { id: "statue_liberty", display: "\uD83D\uDDFD", label: "Statue Of Liberty", color: "#228B22" },
      { id: "mosque_b", display: "\uD83D\uDD4C", label: "Mosque", color: "#FFD700" },
      { id: "shrine_b", display: "\u26E9\uFE0F", label: "Shinto Shrine", color: "#DC143C" },
      { id: "synagogue_b", display: "\uD83D\uDD4D", label: "Synagogue", color: "#9B59B6" },
    ]
  },
  activities: {
    name: "Aktivitas",
    icon: "\uD83C\uDFC3",
    color: "#FF4500",
    cards: [
      { id: "walking_a", display: "\uD83D\uDEB6", label: "Person Walking", color: "#1E90FF" },
      { id: "running_a", display: "\uD83C\uDFC3", label: "Person Running", color: "#FF4500" },
      { id: "cartwheel_a", display: "\uD83E\uDD38", label: "Cartwheeling", color: "#FF1493" },
      { id: "lotus_a", display: "\uD83E\uDDD8", label: "Lotus Position", color: "#9B59B6" },
      { id: "handball_a", display: "\uD83E\uDD3E", label: "Handball", color: "#FFD700" },
      { id: "fencing_a", display: "\uD83E\uDD3A", label: "Fencer", color: "#A9A9A9" },
      { id: "horse_riding_a", display: "\uD83C\uDFC7", label: "Horse Riding", color: "#8B4513" },
      { id: "biking_a", display: "\uD83D\uDEB4", label: "Bicyclist", color: "#228B22" },
      { id: "swimming_a", display: "\uD83C\uDFCA", label: "Swimming", color: "#4682B4" },
      { id: "lifting_a", display: "\uD83C\uDFCB\uFE0F", label: "Weightlifter", color: "#FF8C00" },
      { id: "basketball_a", display: "\u26F9\uFE0F", label: "Bouncing Ball", color: "#FF8C00" },
      { id: "polo_a", display: "\uD83E\uDD3D", label: "Water Polo", color: "#1E90FF" },
      { id: "diving_a", display: "\uD83E\uDD3F", label: "Diving Mask", color: "#1E90FF" },
      { id: "skis_a", display: "\uD83C\uDFBF", label: "Skis", color: "#87CEEB" },
      { id: "juggling_a", display: "\uD83E\uDD39", label: "Juggling", color: "#FF1493" },
      { id: "dancing_w_a", display: "\uD83D\uDC83", label: "Dancing Woman", color: "#FF1493" },
      { id: "dancing_m_a", display: "\uD83D\uDD7A", label: "Dancing Man", color: "#1E90FF" },
      { id: "climbing_a", display: "\uD83E\uDDD7", label: "Climbing", color: "#8B4513" },
      { id: "martial_a", display: "\uD83E\uDD4B", label: "Martial Arts Uniform", color: "#FFFAF0" },
      { id: "wrestling_a", display: "\uD83E\uDD3C", label: "Wrestlers", color: "#DC143C" },
    ]
  },
  stationery: {
    name: "Alat Tulis",
    icon: "\u270F\uFE0F",
    color: "#FFD700",
    cards: [
      { id: "pencil_s", display: "\u270F\uFE0F", label: "Pencil", color: "#FFD700" },
      { id: "black_nib", display: "\u2712\uFE0F", label: "Pen Nib", color: "#2C3E50" },
      { id: "pen_s", display: "\uD83D\uDD8A\uFE0F", label: "Lower Left Ballpoint Pen", color: "#1E90FF" },
      { id: "fountain_pen", display: "\uD83D\uDD8B\uFE0F", label: "Fountain Pen", color: "#2C3E50" },
      { id: "paintbrush_s", display: "\uD83D\uDD8C\uFE0F", label: "Lower Left Paintbrush", color: "#8B4513" },
      { id: "crayon_s", display: "\uD83D\uDD8D\uFE0F", label: "Lower Left Crayon", color: "#FFD700" },
      { id: "memo_s", display: "\uD83D\uDCDD", label: "Memo Pad", color: "#FFD700" },
      { id: "ledger_s", display: "\uD83D\uDCD2", label: "Ledger Notebook", color: "#FF8C00" },
      { id: "notebook_s", display: "\uD83D\uDCD3", label: "Notebook", color: "#FF8C00" },
      { id: "notebook_dec", display: "\uD83D\uDCD4", label: "Notebook With Decorative Cover", color: "#FF1493" },
      { id: "book_closed", display: "\uD83D\uDCD5", label: "Closed Book", color: "#DC143C" },
      { id: "book_open", display: "\uD83D\uDCD6", label: "Open Book", color: "#FFD700" },
      { id: "book_green", display: "\uD83D\uDCD7", label: "Green Book", color: "#228B22" },
      { id: "book_blue", display: "\uD83D\uDCD8", label: "Blue Book", color: "#1E90FF" },
      { id: "book_orange", display: "\uD83D\uDCD9", label: "Orange Book", color: "#FF8C00" },
      { id: "books_s", display: "\uD83D\uDCDA", label: "Books", color: "#9B59B6" },
      { id: "bookmark_tabs", display: "\uD83D\uDCD1", label: "Bookmark Tabs", color: "#DC143C" },
      { id: "bookmark_s", display: "\uD83D\uDD16", label: "Bookmark", color: "#DC143C" },
      { id: "scissors_s", display: "\u2702\uFE0F", label: "Scissors", color: "#A9A9A9" },
      { id: "paperclip_s", display: "\uD83D\uDCCE", label: "Paperclip", color: "#A9A9A9" },
    ]
  },
  money: {
    name: "Uang & Bank",
    icon: "\uD83D\uDCB0",
    color: "#228B22",
    cards: [
      { id: "money_bag", display: "\uD83D\uDCB0", label: "Money Bag", color: "#FFD700" },
      { id: "yen_money", display: "\uD83D\uDCB4", label: "Yen Banknote", color: "#FFA500" },
      { id: "dollar_money", display: "\uD83D\uDCB5", label: "Dollar Banknote", color: "#228B22" },
      { id: "euro_money", display: "\uD83D\uDCB6", label: "Euro Banknote", color: "#4682B4" },
      { id: "pound_money", display: "\uD83D\uDCB7", label: "Pound Banknote", color: "#9B59B6" },
      { id: "money_wings", display: "\uD83D\uDCB8", label: "Money With Wings", color: "#FFD700" },
      { id: "credit_card", display: "\uD83D\uDCB3", label: "Credit Card", color: "#1E90FF" },
      { id: "bank_money", display: "\uD83C\uDFE6", label: "Bank Building", color: "#FFD700" },
      { id: "coin_money", display: "\uD83E\uDE99", label: "Coin", color: "#DAA520" },
      { id: "bar_chart_money", display: "\uD83D\uDCCA", label: "Bar Chart", color: "#1E90FF" },
      { id: "chart_up", display: "\uD83D\uDCC8", label: "Chart Increasing", color: "#228B22" },
      { id: "chart_down", display: "\uD83D\uDCC9", label: "Chart Decreasing", color: "#DC143C" },
      { id: "receipt_money", display: "\uD83E\uDDFE", label: "Receipt", color: "#FFFAF0" },
      { id: "shopping_bags", display: "\uD83D\uDECD\uFE0F", label: "Shopping Bags", color: "#FF1493" },
      { id: "shopping_cart", display: "\uD83D\uDED2", label: "Shopping Cart", color: "#FFD700" },
      { id: "dollar_sign", display: "\uD83D\uDCB2", label: "Heavy Dollar Sign", color: "#228B22" },
      { id: "money_face", display: "\uD83E\uDD11", label: "Money Mouth Face", color: "#228B22" },
      { id: "atm_money", display: "\uD83C\uDFE7", label: "ATM Sign", color: "#1E90FF" },
      { id: "currency_exchange", display: "\uD83D\uDCB1", label: "Currency Exchange", color: "#FFD700" },
      { id: "wallet", display: "\uD83D\uDC5B", label: "Purse", color: "#DC143C" },
    ]
  },
  nature: {
    name: "Alam & Gunung",
    icon: "\u26F0\uFE0F",
    color: "#228B22",
    cards: [
      { id: "snow_mountain", display: "\uD83C\uDFD4\uFE0F", label: "Snow Capped Mountain", color: "#A9A9A9" },
      { id: "mountain_nat", display: "\u26F0\uFE0F", label: "Mountain", color: "#8B4513" },
      { id: "volcano_nat", display: "\uD83C\uDF0B", label: "Volcano Erupting", color: "#DC143C" },
      { id: "mount_fuji", display: "\uD83D\uDDFB", label: "Mount Fuji", color: "#1E90FF" },
      { id: "camping_nat", display: "\uD83C\uDFD5\uFE0F", label: "Camping Site", color: "#228B22" },
      { id: "beach_nat", display: "\uD83C\uDFD6\uFE0F", label: "Beach With Umbrella", color: "#FFD700" },
      { id: "desert_nat", display: "\uD83C\uDFDC\uFE0F", label: "Desert", color: "#DAA520" },
      { id: "desert_island_nat", display: "\uD83C\uDFDD\uFE0F", label: "Desert Island", color: "#228B22" },
      { id: "park_nat", display: "\uD83C\uDFDE\uFE0F", label: "National Park", color: "#228B22" },
      { id: "sunrise_nat", display: "\uD83C\uDF05", label: "Sunrise", color: "#FFA500" },
      { id: "sunrise_mountains", display: "\uD83C\uDF04", label: "Sunrise Over Mountains", color: "#FF8C00" },
      { id: "sunset_nat", display: "\uD83C\uDF07", label: "Sunset", color: "#FF4500" },
      { id: "cityscape_dusk", display: "\uD83C\uDF06", label: "Cityscape At Dusk", color: "#9B59B6" },
      { id: "cityscape_nat", display: "\uD83C\uDFD9\uFE0F", label: "Cityscape", color: "#A9A9A9" },
      { id: "night_stars", display: "\uD83C\uDF03", label: "Night With Stars", color: "#2C3E50" },
      { id: "railway_track", display: "\uD83D\uDEE4\uFE0F", label: "Railway Track", color: "#8B4513" },
      { id: "motorway", display: "\uD83D\uDEE3\uFE0F", label: "Motorway", color: "#A9A9A9" },
      { id: "map_nat", display: "\uD83D\uDDFA\uFE0F", label: "World Map", color: "#DEB887" },
      { id: "globe_nat", display: "\uD83C\uDF10", label: "Globe With Meridians", color: "#1E90FF" },
      { id: "earth_africa", display: "\uD83C\uDF0D", label: "Earth Globe Europe Africa", color: "#228B22" },
    ]
  },
  hands: {
    name: "Tangan",
    icon: "\u270B",
    color: "#FFB6C1",
    cards: [
      { id: "waving_h", display: "\uD83D\uDC4B", label: "Waving Hand", color: "#FFB6C1" },
      { id: "raised_back_h", display: "\uD83E\uDD1A", label: "Raised Back Of Hand", color: "#FFB6C1" },
      { id: "splayed_h", display: "\uD83D\uDD90\uFE0F", label: "Hand With Fingers Splayed", color: "#FFB6C1" },
      { id: "raised_h", display: "\u270B", label: "Raised Hand", color: "#FFB6C1" },
      { id: "vulcan_h", display: "\uD83D\uDD96", label: "Vulcan Salute", color: "#FFB6C1" },
      { id: "ok_h", display: "\uD83D\uDC4C", label: "OK Hand", color: "#FFB6C1" },
      { id: "pinching_h", display: "\uD83E\uDD0F", label: "Pinching Hand", color: "#FFB6C1" },
      { id: "pinched_h", display: "\uD83E\uDD0C", label: "Pinched Fingers", color: "#FFB6C1" },
      { id: "victory_h", display: "\u270C\uFE0F", label: "Victory Hand", color: "#FFB6C1" },
      { id: "crossed_fingers", display: "\uD83E\uDD1E", label: "Crossed Fingers", color: "#FFB6C1" },
      { id: "love_you_h", display: "\uD83E\uDD1F", label: "Love You Gesture", color: "#FFB6C1" },
      { id: "horns_h", display: "\uD83E\uDD18", label: "Sign Of The Horns", color: "#FFB6C1" },
      { id: "call_me_h", display: "\uD83E\uDD19", label: "Call Me Hand", color: "#FFB6C1" },
      { id: "point_left", display: "\uD83D\uDC48", label: "Backhand Index Pointing Left", color: "#FFB6C1" },
      { id: "point_right", display: "\uD83D\uDC49", label: "Backhand Index Pointing Right", color: "#FFB6C1" },
      { id: "point_up_h", display: "\uD83D\uDC46", label: "Backhand Index Pointing Up", color: "#FFB6C1" },
      { id: "point_down", display: "\uD83D\uDC47", label: "Backhand Index Pointing Down", color: "#FFB6C1" },
      { id: "index_up_h", display: "\u261D\uFE0F", label: "Index Pointing Up", color: "#FFB6C1" },
      { id: "thumb_up_h", display: "\uD83D\uDC4D", label: "Thumbs Up", color: "#FFB6C1" },
      { id: "clap_h", display: "\uD83D\uDC4F", label: "Clapping Hands", color: "#FFB6C1" },
    ]
  },
  balls: {
    name: "Bola Olahraga",
    icon: "\u26BD",
    color: "#FF8C00",
    cards: [
      { id: "soccer_ball", display: "\u26BD", label: "Soccer Ball", color: "#FFFAF0" },
      { id: "basketball_ball", display: "\uD83C\uDFC0", label: "Basketball", color: "#FF8C00" },
      { id: "football_ball", display: "\uD83C\uDFC8", label: "American Football", color: "#8B4513" },
      { id: "baseball_ball", display: "\u26BE", label: "Baseball", color: "#FFFAF0" },
      { id: "softball_ball", display: "\uD83E\uDD4E", label: "Softball", color: "#FFD700" },
      { id: "tennis_ball", display: "\uD83C\uDFBE", label: "Tennis", color: "#FFD700" },
      { id: "volleyball_ball", display: "\uD83C\uDFD0", label: "Volleyball", color: "#FFFAF0" },
      { id: "rugby_ball", display: "\uD83C\uDFC9", label: "Rugby Football", color: "#8B4513" },
      { id: "pool_ball", display: "\uD83C\uDFB1", label: "Pool 8 Ball", color: "#2C3E50" },
      { id: "yoyo_ball", display: "\uD83E\uDE80", label: "Yo-Yo", color: "#FF6347" },
      { id: "flying_disc", display: "\uD83E\uDD4F", label: "Flying Disc", color: "#FF1493" },
      { id: "bowling_ball", display: "\uD83C\uDFB3", label: "Bowling", color: "#DC143C" },
      { id: "golf_ball", display: "\u26F3", label: "Flag In Hole", color: "#228B22" },
      { id: "kite_ball", display: "\uD83E\uDE81", label: "Kite", color: "#1E90FF" },
      { id: "ping_pong", display: "\uD83C\uDFD3", label: "Ping Pong", color: "#DC143C" },
      { id: "badminton_ball", display: "\uD83C\uDFF8", label: "Badminton", color: "#FFD700" },
      { id: "curling_stone", display: "\uD83E\uDD4C", label: "Curling Stone", color: "#FFFAF0" },
      { id: "lacrosse", display: "\uD83E\uDD4D", label: "Lacrosse", color: "#FF8C00" },
      { id: "boomerang", display: "\uD83E\uDE83", label: "Boomerang", color: "#8B4513" },
      { id: "roller_skate", display: "\uD83D\uDEFC", label: "Roller Skate", color: "#FF1493" },
    ]
  },
  fantasy: {
    name: "Fantasi",
    icon: "\uD83E\uDD84",
    color: "#9B59B6",
    cards: [
      { id: "unicorn", display: "\uD83E\uDD84", label: "Unicorn", color: "#FFB6C1" },
      { id: "dragon_full", display: "\uD83D\uDC09", label: "Dragon", color: "#DC143C" },
      { id: "dragon_face", display: "\uD83D\uDC32", label: "Dragon Face", color: "#228B22" },
      { id: "mage_f", display: "\uD83E\uDDD9", label: "Mage", color: "#9B59B6" },
      { id: "fairy_f", display: "\uD83E\uDDDA", label: "Fairy", color: "#FF1493" },
      { id: "vampire_f", display: "\uD83E\uDDDB", label: "Vampire", color: "#DC143C" },
      { id: "merperson_f", display: "\uD83E\uDDDC", label: "Merperson", color: "#1E90FF" },
      { id: "elf_f", display: "\uD83E\uDDDD", label: "Elf", color: "#228B22" },
      { id: "genie_f2", display: "\uD83E\uDDDE", label: "Genie", color: "#9B59B6" },
      { id: "superhero_f", display: "\uD83E\uDDB8", label: "Superhero", color: "#DC143C" },
      { id: "supervillain_f", display: "\uD83E\uDDB9", label: "Supervillain", color: "#2C3E50" },
      { id: "prince_f", display: "\uD83E\uDD34", label: "Prince", color: "#FFD700" },
      { id: "princess_f", display: "\uD83D\uDC78", label: "Princess", color: "#FFB6C1" },
      { id: "crown_f", display: "\uD83D\uDC51", label: "Princess Crown", color: "#FFD700" },
      { id: "magic_wand_f", display: "\uD83E\uDE84", label: "Magic Wand", color: "#9B59B6" },
      { id: "sparkles_f", display: "\u2728", label: "Magic Sparkles", color: "#FFD700" },
      { id: "glowing_star_f", display: "\uD83C\uDF1F", label: "Glowing Star", color: "#FFD700" },
      { id: "crystal_ball_f", display: "\uD83D\uDD2E", label: "Crystal Ball", color: "#9B59B6" },
      { id: "castle_f", display: "\uD83C\uDFF0", label: "Fairy Castle", color: "#A9A9A9" },
      { id: "fox_f", display: "\uD83E\uDD8A", label: "Cunning Fox", color: "#FF8C00" },
    ]
  },
  zoo: {
    name: "Kebun Binatang",
    icon: "\uD83E\uDD92",
    color: "#228B22",
    cards: [
      { id: "giraffe_zoo", display: "\uD83E\uDD92", label: "Giraffe Zoo", color: "#FFD700" },
      { id: "zebra_zoo", display: "\uD83E\uDD93", label: "Zebra Zoo", color: "#2C3E50" },
      { id: "kangaroo_zoo", display: "\uD83E\uDD98", label: "Kangaroo Zoo", color: "#A0522D" },
      { id: "hedgehog_zoo", display: "\uD83E\uDD94", label: "Hedgehog Zoo", color: "#8B4513" },
      { id: "badger_zoo", display: "\uD83E\uDDA1", label: "Badger Zoo", color: "#2C3E50" },
      { id: "otter_zoo", display: "\uD83E\uDDA6", label: "Otter Zoo", color: "#8B4513" },
      { id: "sloth_zoo", display: "\uD83E\uDDA5", label: "Sloth Zoo", color: "#A0522D" },
      { id: "skunk_zoo", display: "\uD83E\uDDA8", label: "Skunk Zoo", color: "#2C3E50" },
      { id: "raccoon_zoo", display: "\uD83E\uDD9D", label: "Raccoon Zoo", color: "#A9A9A9" },
      { id: "wolf_zoo", display: "\uD83D\uDC3A", label: "Wolf Zoo", color: "#808080" },
      { id: "boar_zoo", display: "\uD83D\uDC17", label: "Boar Zoo", color: "#8B4513" },
      { id: "hippo_zoo", display: "\uD83E\uDD9B", label: "Hippo Zoo", color: "#9370DB" },
      { id: "rhino_zoo", display: "\uD83E\uDD8F", label: "Rhinoceros Zoo", color: "#A9A9A9" },
      { id: "mammoth_zoo", display: "\uD83E\uDDA3", label: "Mammoth Zoo", color: "#8B4513" },
      { id: "beaver_zoo", display: "\uD83E\uDDAB", label: "Beaver Zoo", color: "#A0522D" },
      { id: "deer_zoo", display: "\uD83E\uDD8C", label: "Deer Zoo", color: "#8B4513" },
      { id: "llama_zoo", display: "\uD83E\uDD99", label: "Llama Zoo", color: "#DEB887" },
      { id: "buffalo_zoo", display: "\uD83D\uDC03", label: "Water Buffalo Zoo", color: "#2C3E50" },
      { id: "ox_zoo", display: "\uD83D\uDC02", label: "Ox Zoo", color: "#8B4513" },
      { id: "tiger_zoo", display: "\uD83D\uDC05", label: "Tiger Side Zoo", color: "#FFA500" },
    ]
  },
  playground: {
    name: "Permainan Halaman",
    icon: "\uD83C\uDFA0",
    color: "#FF1493",
    cards: [
      { id: "carousel_p", display: "\uD83C\uDFA0", label: "Carousel Horse", color: "#FF69B4" },
      { id: "ferris_p", display: "\uD83C\uDFA1", label: "Ferris Wheel", color: "#FF1493" },
      { id: "roller_coaster_p", display: "\uD83C\uDFA2", label: "Roller Coaster", color: "#DC143C" },
      { id: "circus_p", display: "\uD83C\uDFAA", label: "Circus Tent", color: "#FF1493" },
      { id: "slide_p", display: "\uD83D\uDEDD", label: "Playground Slide", color: "#FFA500" },
      { id: "swing_p", display: "\uD83D\uDEDE", label: "Wheel Toy", color: "#FF6347" },
      { id: "yo_yo_p", display: "\uD83E\uDE80", label: "Yo Yo Toy", color: "#FF6347" },
      { id: "kite_p", display: "\uD83E\uDE81", label: "Kite Toy", color: "#1E90FF" },
      { id: "roller_skate_p", display: "\uD83D\uDEFC", label: "Roller Skates", color: "#FF1493" },
      { id: "skateboard_p", display: "\uD83D\uDEF9", label: "Skateboard", color: "#8B4513" },
      { id: "bicycle_p", display: "\uD83D\uDEB2", label: "Bicycle Ride", color: "#228B22" },
      { id: "pinata_p", display: "\uD83E\uDE85", label: "Pinata Game", color: "#FFA500" },
      { id: "teddy_p", display: "\uD83E\uDDF8", label: "Teddy Bear Toy", color: "#A0522D" },
      { id: "nesting_doll_p", display: "\uD83E\uDE86", label: "Nesting Doll", color: "#DC143C" },
      { id: "balloon_p", display: "\uD83C\uDF88", label: "Party Balloon", color: "#FF6347" },
      { id: "gift_p", display: "\uD83C\uDF81", label: "Gift Box", color: "#DC143C" },
      { id: "party_popper_p", display: "\uD83C\uDF89", label: "Party Popper", color: "#FF1493" },
      { id: "confetti_p", display: "\uD83C\uDF8A", label: "Confetti Ball", color: "#FFD700" },
      { id: "juggling_p", display: "\uD83E\uDD39", label: "Juggling Game", color: "#FF1493" },
      { id: "dancing_p", display: "\uD83D\uDC83", label: "Dancing", color: "#FF1493" },
    ]
  },
  traffic: {
    name: "Lalu Lintas",
    icon: "\uD83D\uDEA6",
    color: "#DC143C",
    cards: [
      { id: "traffic_vert", display: "\uD83D\uDEA6", label: "Vertical Traffic Light", color: "#DC143C" },
      { id: "traffic_horiz", display: "\uD83D\uDEA5", label: "Horizontal Traffic Light", color: "#FFD700" },
      { id: "stop_sign", display: "\uD83D\uDED1", label: "Stop Sign", color: "#DC143C" },
      { id: "no_entry", display: "\u26D4", label: "No Entry", color: "#DC143C" },
      { id: "construction", display: "\uD83D\uDEA7", label: "Construction Barrier", color: "#FFA500" },
      { id: "children_xing", display: "\uD83D\uDEB8", label: "Children Crossing", color: "#FFA500" },
      { id: "fuel_pump", display: "\u26FD", label: "Fuel Pump", color: "#228B22" },
      { id: "bus_stop", display: "\uD83D\uDE8F", label: "Bus Stop", color: "#FFA500" },
      { id: "motorway_t", display: "\uD83D\uDEE3\uFE0F", label: "Motorway", color: "#A9A9A9" },
      { id: "railway_t", display: "\uD83D\uDEE4\uFE0F", label: "Railway Track", color: "#8B4513" },
      { id: "metro_t", display: "\uD83D\uDE87", label: "Metro", color: "#4682B4" },
      { id: "light_rail", display: "\uD83D\uDE88", label: "Light Rail", color: "#FF8C00" },
      { id: "station", display: "\uD83D\uDE89", label: "Station", color: "#A9A9A9" },
      { id: "tram", display: "\uD83D\uDE8A", label: "Tram", color: "#FFA500" },
      { id: "parking", display: "\uD83C\uDD7F\uFE0F", label: "P Button Parking", color: "#1E90FF" },
      { id: "no_littering", display: "\uD83D\uDEAF", label: "No Littering", color: "#DC143C" },
      { id: "potable_water", display: "\uD83D\uDEB0", label: "Potable Water", color: "#1E90FF" },
      { id: "non_potable", display: "\uD83D\uDEB1", label: "Non Potable Water", color: "#DC143C" },
      { id: "litter_bin", display: "\uD83D\uDEAE", label: "Litter In Bin Sign", color: "#228B22" },
      { id: "pedestrian", display: "\uD83D\uDEB6", label: "Pedestrian Crossing", color: "#FFD700" },
    ]
  },
  seasons: {
    name: "Cuaca 4 Musim",
    icon: "\uD83C\uDF38",
    color: "#FF69B4",
    cards: [
      { id: "spring_blossom", display: "\uD83C\uDF38", label: "Spring Cherry Blossom", color: "#FFB6C1" },
      { id: "spring_tulip", display: "\uD83C\uDF37", label: "Spring Tulip", color: "#FF1493" },
      { id: "spring_rose", display: "\uD83C\uDF39", label: "Spring Rose", color: "#DC143C" },
      { id: "summer_sunflower", display: "\uD83C\uDF3B", label: "Summer Sunflower", color: "#FFD700" },
      { id: "summer_palm", display: "\uD83C\uDF34", label: "Summer Palm Tree", color: "#228B22" },
      { id: "summer_sun", display: "\u2600\uFE0F", label: "Summer Sun", color: "#FFD700" },
      { id: "summer_beach", display: "\uD83C\uDFD6\uFE0F", label: "Summer Beach", color: "#FFD700" },
      { id: "autumn_maple", display: "\uD83C\uDF41", label: "Autumn Maple Leaf", color: "#DC143C" },
      { id: "autumn_fallen", display: "\uD83C\uDF42", label: "Autumn Fallen Leaf", color: "#FF8C00" },
      { id: "autumn_leaf", display: "\uD83C\uDF43", label: "Autumn Leaf In Wind", color: "#228B22" },
      { id: "autumn_acorn", display: "\uD83C\uDF30", label: "Autumn Chestnut", color: "#8B4513" },
      { id: "autumn_mushroom", display: "\uD83C\uDF44", label: "Autumn Mushroom", color: "#DC143C" },
      { id: "winter_snowflake", display: "\u2744\uFE0F", label: "Winter Snowflake", color: "#87CEEB" },
      { id: "winter_snowman", display: "\u26C4", label: "Winter Snowman", color: "#FFFAF0" },
      { id: "winter_full_snowman", display: "\u2603\uFE0F", label: "Winter Snowman With Snow", color: "#FFFAF0" },
      { id: "winter_ice", display: "\uD83E\uDDCA", label: "Winter Ice Cube", color: "#87CEEB" },
      { id: "rain_seasons", display: "\uD83C\uDF27\uFE0F", label: "Cloud With Rain", color: "#1E90FF" },
      { id: "rainbow_seasons", display: "\uD83C\uDF08", label: "Rainbow", color: "#FF69B4" },
      { id: "wave_seasons", display: "\uD83C\uDF0A", label: "Water Wave", color: "#1E90FF" },
      { id: "cold_face_seasons", display: "\uD83E\uDD76", label: "Cold Face Winter", color: "#87CEEB" },
    ]
  },
};

// Shuffle array function
export const shuffleArray = (array) => {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};

// Create game board with pairs
export const createMemoryBoard = (category, pairCount = 6) => {
  const categoryData = CARD_CATEGORIES[category];
  if (!categoryData) return [];
  const selectedCards = categoryData.cards.slice(0, pairCount);
  const pairs = [];
  selectedCards.forEach((card, index) => {
    pairs.push({ ...card, uniqueId: `${card.id}-1`, pairIndex: index });
    pairs.push({ ...card, uniqueId: `${card.id}-2`, pairIndex: index });
  });
  return shuffleArray(pairs);
};

// Get grid size based on pair count (total cards = pairCount * 2)
// Max supported: 20 pairs (each category has 20 thematic cards)
export const getGridSize = (pairCount) => {
  const totalCards = pairCount * 2;
  if (totalCards <= 8) return { cols: 4, rows: 2 };     // 4 pairs
  if (totalCards <= 10) return { cols: 5, rows: 2 };    // 5 pairs
  if (totalCards <= 12) return { cols: 4, rows: 3 };    // 6 pairs
  if (totalCards <= 14) return { cols: 4, rows: 4 };    // 7 pairs (last row 2 empty)
  if (totalCards <= 16) return { cols: 4, rows: 4 };    // 8 pairs
  if (totalCards <= 18) return { cols: 6, rows: 3 };    // 9 pairs
  if (totalCards <= 20) return { cols: 5, rows: 4 };    // 10 pairs
  if (totalCards <= 22) return { cols: 6, rows: 4 };    // 11 pairs
  if (totalCards <= 24) return { cols: 6, rows: 4 };    // 12 pairs
  if (totalCards <= 28) return { cols: 7, rows: 4 };    // 14 pairs
  if (totalCards <= 30) return { cols: 6, rows: 5 };    // 15 pairs
  if (totalCards <= 32) return { cols: 8, rows: 4 };    // 16 pairs
  if (totalCards <= 36) return { cols: 6, rows: 6 };    // 18 pairs
  return { cols: 8, rows: 5 };                          // 20 pairs (max)
};

// Sound effect helpers
const playTone = (frequency, duration, type = 'sine', volume = 0.3) => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime);
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (err) { logger.debug("audio/data op failed", err); }
};

export const playFlipSound = () => playTone(600, 0.15, 'sine', 0.4);
export const playMatchSound = () => {
  playTone(523, 0.15, 'sine', 0.4);
  setTimeout(() => playTone(659, 0.15, 'sine', 0.4), 100);
  setTimeout(() => playTone(784, 0.25, 'sine', 0.4), 200);
};
export const playMismatchSound = () => {
  playTone(200, 0.2, 'square', 0.25);
  setTimeout(() => playTone(160, 0.25, 'square', 0.25), 150);
};
export const playWinSound = () => {
  const notes = [523, 587, 659, 698, 784, 880, 988, 1047];
  notes.forEach((note, i) => {
    setTimeout(() => playTone(note, 0.25, 'sine', 0.35), i * 100);
  });
};
export const playSwitchTurnSound = () => {
  playTone(440, 0.15, 'triangle', 0.3);
  setTimeout(() => playTone(550, 0.2, 'triangle', 0.3), 120);
};

// TTS - speak card name (clear & loud English)
export const speakCardName = (name) => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(name);
  utterance.lang = getVoiceLang();
  utterance.rate = 0.85;
  utterance.pitch = 1.0;
  utterance.volume = 1.0;
  window.speechSynthesis.speak(utterance);
};
